import auction_adding from "./auction-adding";
import enums from "./enums";
import generals from "./generals";
import infoIcons from "./infoIcons";
import ramps from "./ramps";
import ratings from "./ratings";
import routes from "./routes";
import tableDetails from "./tableData";
import tutorial from "./tutorial";
import verificationPayment from "./verificationPayment";
import widgets from "./widgets";

export default {
  enums: enums,
  verificationPayment: verificationPayment,
  tutorial: tutorial,
  auth: {
    register_title_button: "Klicken Sie hier, um sich zu registrieren",
    dont_have_account: "Sie haben noch kein Konto?",
    forgot_password_label: "Passwort vergessen?",
    remember_me_label: "Angemeldet bleiben",
    log_in_label: "Anmelden",
    password_label: "Passwort",
    enter_password_placeholder: "Passwort eingeben",
    enter_email_placeholder: "E-Mail eingeben",
    enter_login_or_email_label: "Benutzername oder E-Mail eingeben",
    error_wrong_login_or_password: "Falscher Benutzername oder falsches Passwort",
    log_in_progress_label: "Anmeldung läuft...",
    server_error_short: "Serverfehler",
    server_error_try_again: "Interner Serverfehler. Bitte versuchen Sie es später erneut.",
    email_is_required: "E-Mail-Adresse ist erforderlich",
    password_is_required: "Passwort ist erforderlich",
    user_not_verified:
      "Das Konto wurde noch nicht verifiziert. Ein Bestätigungslink wurde an die bei der Registrierung angegebene E-Mail-Adresse gesendet.",
    wrong_password: "Falsches Passwort.",
    regulations_acceptance_first: "Ich habe die Datenschutzrichtlinie gelesen",
    regulations_acceptance_second: "Ich habe die Nutzungsbedingungen gelesen",
    regulationsAcceptance: "Sie müssen die Nutzungsbedingungen akzeptieren",
    privacyAcceptance: "Sie müssen die Datenschutzrichtlinie akzeptieren",
    gus: "Fülle die Firmendaten anhand der Steuernummer aus.",
    gus_correct: "Übereinstimmung gefunden. GUS-Daten anzeigen",
    gus_incorrect: "Keine Übereinstimmung. GUS-Daten anzeigen",
    workers: "XLplanner-Mitarbeiter",
    same_passwords: "Das aktuelle und das neue Passwort müssen unterschiedlich sein",
  },
  register: {
    select_country: "Land auswählen",
    select_country_description: "Wählen Sie das Land, in dem Ihr Unternehmen registriert ist",
    choose_account_type_to_go_further: "Sie müssen einen Kontotyp auswählen, um fortzufahren",
    confirming_e_mail_has_been_sent: "Die Bestätigungs-E-Mail wurde erneut gesendet!",
    message: "Nachrichtentext",
    inviteCompany: "Einladung an XLplanner senden",
    inviteCompanyShort: "Einladung senden",
    addWorker: "Mitarbeiter hinzufügen",
    role: "Rolle",
    admin: "Administrator",
    worker: "Mitarbeiter",
    account_type: "Kontotyp",
    typeToChange: "Kontotyp ändern zu:",
    empty_account_type_placeholder: "Kein Kontotyp",
    company_data: "Firmendaten",
    user_data: "Benutzerdaten",
    pick_type: "Kontotyp auswählen",
    enter_company_data: "Firmendaten eingeben",
    enter_user_data: "Benutzerdaten eingeben",
    company: "Firmenname",
    address_placeholder: "Firmenadresse eingeben",
    city: "Stadt",
    city_placeholder: "Stadt eingeben",
    country: "Land",
    country_placeholder: "Land eingeben",
    zipCode: "Postleitzahl",
    zipCode_placeholder: "Postleitzahl eingeben",
    nip_placeholder: "Steuernummer eingeben",
    company_placeholder: "Firmenname eingeben",
    address: "Firmenadresse",
    zip_code: "Postleitzahl",
    nip: "Steuernummer",
    email: "E-Mail",
    email_placeholder: "E-Mail eingeben",
    name: "Vorname",
    name_placeholder: "Vorname eingeben",
    phone: "Telefonnummer",
    appellation: "Name",
    phone_placeholder: "Telefonnummer eingeben",
    surname: "Nachname",
    surname_placeholder: "Nachname eingeben",
    user_role: "Ich bin",
    password: "Passwort",
    password_placeholder: "Passwort eingeben",
    confirm_password: "Passwort bestätigen",
    confirm_password_placeholder: "Passwort bestätigen",
    regulations_acceptance_first: "Ich akzeptiere die",
    regulations_acceptance_second: "Nutzungsbedingungen",
    regulations_acceptance_third: "und die",
    regulations_acceptance_fourth: "Datenschutzrichtlinie.",
    personal_data_processing_agreement: "Ich stimme der Speicherung meiner personenbezogenen Daten zu",
    other_processing_agreement:
      "Im Rahmen der in diesem Vertrag erbrachten Dienstleistungen stellt PayPro dem Händler einen zusätzlichen Mechanismus zur Verfügung, der die Erfassung von Zahlerdaten (Vorname, Nachname, Adresse, IBAN) auf Grundlage einer Verifizierungsüberweisung (GeTPayerInfo) ermöglicht. Die in dem vorstehenden Satz genannten personenbezogenen Daten dürfen nur nach freiwilliger Zustimmung des Zahlers offengelegt und vom Händler ausschließlich zu dem in dieser Zustimmung angegebenen Zweck und Umfang verarbeitet werden. Der Inhalt einer solchen Zustimmung ist Punkt 1 dieses Anhangs:",
    other_processing_agreement2:
      "1. „Ich stimme der Übermittlung meiner personenbezogenen Daten durch den Datenverantwortlichen PayPro SA mit Sitz in Poznań (60-198), Pastelowa-Straße 8, an ANOTHER INVEST Sp. z o.o. zu, die aus der von mir über PayPro SA durchgeführten Zahlungstransaktion stammen, zum Zweck meiner Überprüfung durch ANOTHER INVEST Sp. z o.o., einschließlich der Betrugsanalyse. Die Datenübermittlung umfasst: Vor- und Nachname, Adresse, IBAN-Nummer. Die Zustimmung ist freiwillig, aber ihre Abwesenheit kann eine Verifizierungsüberweisung vom Bankkonto des Kunden erfordern. Diese Zustimmung kann jederzeit widerrufen werden; der Widerruf berührt jedoch nicht die Rechtmäßigkeit der Verarbeitung vor dem Widerruf.“",
    cancel: "Abbrechen",
    create_account: "Konto erstellen",
    creating_account_in_progress: "Konto wird erstellt...",
    error_while_creating_user: "Beim Erstellen des Kontos ist ein Fehler aufgetreten. Überprüfen Sie die Daten und versuchen Sie es erneut.",
    success: "Konto erfolgreich erstellt!",
    email_verification: "Ein Bestätigungslink wurde an die angegebene E-Mail-Adresse gesendet.",
    verification_sent: "Vielen Dank für Ihre Registrierung. Sie können sich jetzt anmelden und das System nutzen.",
    verification_link_sent:
      "Ein Bestätigungslink wurde an Ihre E-Mail-Adresse gesendet. Klicken Sie auf den Link, um Ihr Konto zu bestätigen und sich anzumelden.",
    choose_licenses_description: "Wählen Sie die Lizenzen aus, über die Ihr Unternehmen verfügt.",
    search_country: "Land suchen...",
    no_country_found: "Land nicht gefunden",
    validation: {
      at_least_one_license: "Lizenz erforderlich",
      maxCharacters: "Maximale Zeichenanzahl ist",
      string: "Dieses Feld muss Text enthalten",
      required: "Dieses Feld ist erforderlich",
      email: "Dieses Feld muss eine gültige E-Mail-Adresse enthalten",
      max: "Dieses Feld darf maximal {number} Zeichen enthalten",
      password: "Das Passwort muss mindestens enthalten: 8 Zeichen, 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Sonderzeichen und 1 Zahl",
      passwordConfirmation: "Passwörter müssen übereinstimmen",
      regulationsAcceptance: "Sie müssen die Nutzungsbedingungen akzeptieren",
      additionalRegulations: "Sie müssen die zusätzlichen Bedingungen akzeptieren",
      dataProcessing: "Zustimmung zur Datenverarbeitung",
      userRole: "Ungültige Rolle ausgewählt",
      phone: "Ungültige Telefonnummer",
      name: "Vor- und Nachname dürfen nicht leer sein",
      wrongName: "Ungültiger Vorname",
      wrongSurname: "Ungültiger Nachname",
      wrongCity: "Ungültige Stadt",
      wrongCountry: "Ungültiges Land",
      allRequired: "Bitte füllen Sie alle Felder aus",
      onlyNumberInWeight: "Dieses Feld darf nur Zahlen enthalten",
      onlyNumberInVolume: "Dieses Feld darf nur Zahlen enthalten",
      onlyNumberInLength: "Dieses Feld darf nur Zahlen enthalten",
      onlyNumberInPalltesAmount: "Dieses Feld darf nur Zahlen enthalten",
      role: "Ungültige Rolle ausgewählt",
      enterNip: "Geben Sie eine gültige Steuernummer ein, um Firmendaten zu laden.",
    },
  },
  forgot_password: {
    reset_password_title: "Passwort zurücksetzen",
    text: "Wenn Sie Ihr Kontopasswort vergessen haben, geben Sie bitte Ihre E-Mail-Adresse ein.\nWir senden Ihnen eine Nachricht, um Ihr Passwort zurückzusetzen.",
    enter_email_placeholder: "E-Mail eingeben",
    sending: "Wird gesendet...",
    send_button: "Senden",
    back_button: "Zurück",
    success_text:
      "Wir haben Anweisungen zum Zurücksetzen des Passworts an Ihre E-Mail-Adresse gesendet. Wenn Sie die Nachricht nicht erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner und stellen Sie sicher, dass diese E-Mail auf der XLplanner-Website registriert ist.",
    resend_email_again: "E-Mail erneut senden",
    still_no_email: "Immer noch keine E-Mail?",
    success_send_again: "E-Mail erfolgreich erneut gesendet",
    fail_send_again:
      "Die E-Mail wurde gesendet. Wenn Sie sie weiterhin nicht erhalten haben, stellen Sie bitte sicher, dass Sie im System registriert sind.",
  },
  reset_password: {
    title: "Passwort zurücksetzen",
    verification_code: "Verifizierungscode",
    verification_code_placeholder: "Verifizierungscode eingeben",
    password: "Neues Passwort",
    password_placeholder: "Neues Passwort eingeben",
    confirm_password: "Passwort bestätigen",
    confirm_password_placeholder: "Neues Passwort bestätigen",
    change_password: "Passwort ändern",
    changing_password_in_progress: "Passwort wird geändert...",
    ready: "Fertig!",
    password_changed: "Das Passwort wurde erfolgreich geändert.",
    click_to_go_to_login: "Klicken Sie hier, um zum Login-Bildschirm zu gelangen",
    invalid_code: "Der Link zum Zurücksetzen des Passworts ist abgelaufen. Erstellen Sie einen neuen und versuchen Sie es erneut.",
  },

  profile: {
    processing: "Verarbeitung...",
    worker_subscription_payment: "Mitarbeiter-Abonnement-Zahlung",
    paying_for_worker: "Abonnement-Zahlung für: {name} {surname}",
    worker_subscription_description: "Wählen Sie Ihren bevorzugten Zahlungsanbieter, um fortzufahren.",
    proceed_to_payment: "Zur Zahlung gehen",
    waiting_for_acceptance: "Sie warten auf die Bestätigung des Administrators. Bis dahin können einige Funktionen nicht verfügbar sein.",
    subscription_payment_title: "Abonnement für neuen Mitarbeiter bezahlen",
    worker_added_successfully: "Mitarbeiter {name} {surname} wurde erfolgreich hinzugefügt!",
    subscription_payment_description: "Damit der Mitarbeiter das System nutzen kann, muss ein Abonnement für ihn bezahlt werden.",
    subscription_days: "Anzahl der Tage",
    subscription_price: "Preis",
    pay_subscription_button: "Für Abonnement bezahlen",
    you_need_subscription: "Sie müssen ein aktives Abonnement haben, um die volle Funktionalität der Anwendung nutzen zu können.",
    you_have_unadded_documents: "Ihr Unternehmen hat nicht hinzugefügte Pflichtdokumente.",
    you_have_unverified_documents:
      "Ihr Unternehmen hat nicht verifizierte Dokumente. Bitte warten Sie auf die Verifizierung durch den Administrator.",
    what_do_you_want_to_add: "Was möchten Sie hinzufügen?",
    choose_one_of_the_options: "Wählen Sie eine der folgenden Optionen, um zum Bildschirm mit dem Hinzufügungsformular zu gelangen.",
    my_profile_title: "Mein Profil",
    close_edit_title: "Bearbeitung schließen",
    change_image_title: "Bild ändern",
    upload_image_title: "Bild hochladen",
    remove_image: "Entfernen",
    specjalizations: "Spezialisierungen",
    add_new_tag: "Neues Tag hinzufügen",
    enter_tag_placeholder: "Tag eingeben",
    my_profile_edit_title: "Profil bearbeiten",
    specialization_title: "Spezialisierungen",
    description_title: "Beschreibung",
    basic_company_data_title: "Grundlegende Unternehmensdaten",
    button_label: "Informationen aktualisieren",
    updating: "Aktualisierung",
    enter_link_placeholder: "Link zum Profil eingeben",
    choose_label: "Auswählen",
    your_profile: "Ihr Profil",
    edit_company: "Bearbeitung der Unternehmensdaten",
    remove_img: "Bild entfernen",
    role: {
      driving_license: "Pilotenlizenz",
      car_license: "Fahrzeuglizenz",
      worker_license: "Pilotenlizenz",
      pilot: "Pilot",
      client: "Kunde",
      temp: "Extern",
      admin: "Manager",
      driver: "Spediteur",
      warehouse: "Lager",
      factory: "Hersteller",
      user: "Benutzer",
      owner: "Administrator",
      worker: "Mitarbeiter",
      car_policy: "Fahrzeugpolice",
      administrator: "Manager",
      auta_solowe: "Solo-Fahrzeuge",
      autolaweta_laweta: "Autotransporter",
      wywrotka: "Kipper",
      ciągniki_siodłowe: "Sattelzugmaschinen",
      ciagniki_siodlowe: "Sattelzugmaschinen",
      hakowiec: "Hakenliftwagen",
      walkingfloor: "Walking-Floor-Kipper",
      bdf_system_przyczepa: "BDF-System",
      dluzyca: "Langholzanhänger",
      dluzyca_przyczepa: "Langholzanhänger",
      dluzyca_naczepa: "Langholz-Sattelanhänger",
      plandeka_bde: "Plane BDE",
      plandeka_coilmulde: "Plane Coilmulde",
      plandeka_joloda: "Plane Joloda",
      plandeka_jumbo: "Plane Jumbo",
      plandeka_mega: "Plane Mega",
      plandeka_standard: "Plane Standard",
      sztywna_zabudowa: "Starrer Aufbau",
      sztywna_zabudowa_skrzynia: "Starrer Aufbau Kasten",
      chlodnia_hakowka: "Kühlanhänger Haken",
      cysterna_inna: "Tankwagen sonstige",
      cysterna_silos: "Silo-Tankwagen",
      cysterna_spożywcza: "Lebensmittel-Tankwagen",
      podkontenerowa_20_cysterna: "Container 20' Tankwagen",
      podkontenerowa_40_cysterna: "Container 40' Tankwagen",
      podkontenerowa_20_standard: "Container 20' Standard",
      podkontenerowa_40_standard: "Container 40' Standard",
      podkontenerowa_45_standard: "Container 45' Standard",
      podkontenerowa_swapbody: "Container Wechselbrücke",
      niskopodwoziowy: "Tieflader",
      niskopodwoziowy_naczepa: "Tieflader",
      niskopodwoziowy_przyczepa: "Tieflader-Anhänger",
      bdf_system_naczepa: "BDF-System",
      izoterma: "Isoliert",
      cysterna_chemiczna: "Chemikalien-Tankwagen",
      cysterna_paliwowa: "Kraftstoff-Tankwagen",
      cysterna_gazowa: "Gas-Tankwagen",
      chlodnia: "Kühlwagen",
      platforma: "Plattform",
      tandem: "Tandem",
      samochod: "FAHRZEUG",
      przyczepa: "Anhänger",
      przyczepy: "Anhänger",
      naczepa: "Sattelanhänger",
      naczepy: "Sattelanhänger",
      niestandardowy: "Nicht-Standard-Fahrzeug",
      custom: "Nicht-Standard-Fahrzeug",
      furgon: "Kastenwagen",
      loading: "Beladung",
      reloading: "Umladung",
      unloading: "Entladung",
      krs_cdig: "CEIDG",
      tilt_curtain: "Plane Gardine",
      plandeks_firanka: "Plane Gardine",
      auto: "Auto",
      regon: "Regon",
      nip: "Steuernummer",
      file: "Sonstige",
      carrier_insurance: "Versicherung",
      transport_license: "Lizenz",
      contract_terms: "Vertragsbedingungen",
      npe_application: "Leasingantrag",
      errors: {
        404: "Die Rolle des Mitarbeiters kann nicht geändert werden, da das Unternehmen inaktiv ist",
        empty_company: "Unternehmen nicht gefunden",
        empty_user: "Mitarbeiter nicht gefunden",
        documents_error: "Zur Durchführung der Aktion sind verifizierte Dokumente erforderlich.",
      },
    },
    statuses: {
      assigned: "Zugewiesen",
      lost: "Angebot nicht ausgewählt",
      waiting_for_acceptance: "Wartet auf Autorisierung",
      waiting_for_reservation: "Wartet auf Reservierung",
      waiting_for_payment: "Wartet auf Zahlung",
      reservation_sent: "Eingereicht",
      invitation_sent: "Wartet auf Autorisierung",
      activated: "Autorisiert",
      active: "Aktiv",
      blocked: "Blockiert",
      deleted: "Gelöscht",
      pending: "Ausstehend",
      absent: "Kein Fahrzeug",
      current: "In Bearbeitung",
      available: "Frei",
      rejected: "Abgelehnt",
      retreated: "Zurückgezogen",
      accepted: "Autorisiert",
      all: "Alle",
      finished: "Im Archiv",
      reserved: "Reserviert",
      multiple_blocked: "Blockiert",
      multiple_active: "Aktiv",
      multiple_rejected: "Abgelehnt",
      loading: "Beladung",
      reloading: "Entladung",
      unloading: "Entladung",
      cancelled: "Storniert",
      car_pending: "Kein Fahrzeug",
      car_available: "Fahrzeug frei",
      current_monitary: "In Bearbeitung",
      car_ended: "Beendet",
      completed: "Erfolgreich abgeschlossen",
      not_completed: "Nicht abgeschlossen",
      waiting_to_start: "Wartet auf Beginn",
      started: "Gestartet",
      WAITING_FOR_VERIFICATION: "Wartet auf Verifizierung",
    },
    statuses_monitory: {
      rejected: "Abgelehnt",
      cancelled: "Storniert",
      finished: "Im Archiv",
      accepted: "Bestätigt",
      pending: "Ausstehend",
      current: "In Bearbeitung",
      all: "Alle",
      absent: "Kein Fahrzeug",
      waiting_for_acceptance: "Ausstehend",
    },
    company: {
      display_name: "Anzeigename",
      display_name_placeholder: "Anzeigename...",
      please_pick_one_license: "Bitte wählen Sie mindestens eine Lizenz aus und fügen Sie das entsprechende Dokument hinzu",
      company_data: "Unternehmensdaten",
      my_company: "Mein Unternehmen",
      edit: "Unternehmensdaten bearbeiten",
      basic_data: "Grundlegende Unternehmensdaten",
      name: "Firmenname",
      address: "Unternehmensadresse",
      city: "Stadt",
      zip_code: "Postleitzahl",
      nip: "Steuernummer",
      regon: "Regon",
      province: "Bundesland",
      update_success: "Daten erfolgreich aktualisiert",
      addWorker: "Mitarbeiter erfolgreich hinzugefügt. Bitte warten Sie auf dessen Bestätigung durch den Systemadministrator.",
      avatar: "Firmenprofilbild",
      galery: "Firmengalerie",
      showGalery: "Klicken Sie, um die ganze Galerie zu sehen",
      emptyCompany: "Sie sind bei keinem Unternehmen registriert",
      administrator_amount: "Anzahl der Administratoren",
      department_amount: "Anzahl der Abteilungen",
      you_dont_own_departments: "Sie haben keine Abteilungen",
      validation: {
        display_name_max: "Der Anzeigename kann bis zu 50 Zeichen lang sein.",
        compnay: "Der Firmenname muss eine Zeichenkette sein",
        address: "Die Adresse muss eine Zeichenkette sein",
        zip_code: "Ungültige Postleitzahl. Min. Anzahl von Zeichen ist 3. Max. Anzahl von Zeichen ist 10.",
        zip_code_pl: "Ungültige Postleitzahl. Korrektes Format ist XX-XXX.",
        max_nip: "Die Steuernummer muss aus min. 9 Ziffern bestehen",
        regon_only_number: "Regon muss eine Ziffernfolge sein",
        max_regon: "Regon muss aus 9 Ziffern bestehen",
        authorizationError: "Keine Berechtigung zur Bearbeitung",
      },
    },
    personal_data: {
      basic_data: "Ihre grundlegenden Daten",
      firstname: "Vorname",
      enter_firstname: "Vorname eingeben",
      lastname: "Nachname",
      enter_lastname: "Nachname eingeben",
      email: "E-Mail",
      enter_email: "E-Mail eingeben",
      phone: "Telefonnummer",
      enter_phone: "Telefonnummer eingeben",
      second_phone: "Telefonnummer 2",
      enter_second_phone: "Telefonnummer 2 eingeben",
      update_info: "Informationen aktualisieren",
      updating_info: "Aktualisierung...",
    },
    validation: {
      wrong_url: "Ungültige URL-Adresse",
      weight: "Das Feld darf nur aus Ziffern bestehen",
      volume: "Das Volumen darf nur aus Ziffern bestehen",
      number_of_pallets: "Die Anzahl der Paletten darf nur aus Ziffern bestehen",
    },
    add_user: {
      driver_add: "Fahrer hinzugefügt",
      licenses: "Lizenzen",
      upload_license_document: "Wählen Sie ein Dokument aus, das die Lizenz bestätigt",
      list: "Mitarbeiterliste",
      title: "Mitarbeiter hinzufügen",
      added_worker: "Neuer Mitarbeiter wurde erfolgreich hinzugefügt",
      email_placeholder: "E-Mail-Adresse des Mitarbeiters eingeben",
      message: "Nachricht (optional)",
      name: "Vorname",
      name_placeholder: "Vorname eingeben",
      surname: "Nachname",
      surname_placeholder: "Nachname eingeben",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      phone_placeholder: "Telefonnummer eingeben",
      add: "Mitarbeiter hinzufügen",
      add_driver: "Fahrer hinzufügen",
      adding: "Hinzufügen...",
      type: "Benutzertyp",
      choose_type: "Benutzertyp auswählen",
      enter_worker_data: "Mitarbeiterdaten eingeben",
      enter_driver_data: "Fahrerdaten eingeben",
      admin: "Manager",
      owner: "Eigentümer",
      status: "Benutzerstatus",
      active: "Aktiv",
      worker: "Mitarbeiter",
      edit_complete: "Mitarbeiterdaten erfolgreich geändert",
      assign_department: "Abteilung zuweisen",
    },
    add_warehouse: {
      list: "Lagerliste",
      added_warehouse: "Neues Lager erfolgreich hinzugefügt",
      added_department: "Neue Abteilung erfolgreich hinzugefügt",
      title: "Neues Lager hinzufügen",
      edit_title: "Lager bearbeiten",
      name: "Name",
      name_placeholder: "Lagername eingeben",
      address: "Lageradresse",
      city: "Ort",
      city_placeholder: "Stadt eingeben",
      street: "Straße und Nummer",
      street_placeholder: "Lageradresse eingeben",
      zipCode: "Postleitzahl",
      zipCode_placeholder: "Postleitzahl eingeben",
      country_code: "Ländercode",
      country_code_placeholder: "Ländercode eingeben",
      email_placeholder: "E-Mail-Adresse des Lagers eingeben",
      phone_placeholder: "Telefonnummer des Lagers eingeben",
      type: "Autorisierungstyp",
      automatic: "Automatisch",
      add: "Lager hinzufügen",
      adding: "Lager wird hinzugefügt...",
      delete_complete: "Lager erfolgreich gelöscht",
      edit_complete: "Bearbeitung erfolgreich abgeschlossen.",
      invitation_sent: "Mitarbeiter zur Abteilung hinzugefügt",
    },
    add_department: {
      list: "Abteilungsliste",
      added_warehouse: "Neue Abteilung erfolgreich hinzugefügt",
      title: "Abteilung hinzufügen",
      edit_title: "Abteilung bearbeiten",
      name: "Name",
      name_placeholder: "Name eingeben",
      address: "Abteilungsadresse",
      city: "Ort",
      city_placeholder: "Stadt eingeben",
      street: "Straße und Nummer",
      street_placeholder: "Adresse eingeben",
      zipCode: "Postleitzahl",
      zipCode_placeholder: "Postleitzahl eingeben",
      country_code: "Ländercode",
      country_code_placeholder: "Ländercode eingeben",
      email_placeholder: "E-Mail-Adresse eingeben",
      phone_placeholder: "Telefonnummer eingeben",
      type: "Autorisierungstyp",
      automatic: "Automatisch",
      add: "Abteilung hinzufügen",
      adding: "Abteilung wird hinzugefügt...",
      delete_complete: "Abteilung erfolgreich gelöscht",
      edit_complete: "Abteilung erfolgreich bearbeitet",
      no_download: "Daten bezüglich Abteilung/Lager können nicht heruntergeladen werden.",
      authorizationHint:
        "Die Autorisierung mit dem Spediteur ist für die Durchführung von Avisierungen erforderlich. Sie autorisieren durch die Annahme einer vom Spediteur gesendeten Anfrage. Nach Aktivierung dieser Option werden alle an dieses Lager gesendeten Anfragen automatisch ohne manuelle Bestätigung akzeptiert.",
    },
    add_car: {
      policy_info:
        "Die von Ihnen hinzugefügte Versicherungspolice muss vom Systemadministrator genehmigt werden. Bis dahin können Sie dieses Fahrzeug nicht verwenden.",
      policy: "Policennummer",
      policy_from: "Gültigkeit der Police (von)",
      policy_to: "Gültigkeit der Police (bis)",
      overview_from: "Gültigkeit der Prüfung (von)",
      overview_to: "Gültigkeit der Prüfung (bis)",
      policy_placeholder: "Policennummer eingeben",
      insurer: "Name des Versicherers",
      insurer_placeholder: "Name des Versicherers eingeben",
      title: "Neues Fahrzeug hinzufügen",
      edit_title: "Fahrzeug bearbeiten",
      name: "Marke",
      name_placeholder: "Fahrzeugmarke eingeben",
      trailerNumber: "Kennzeichen des Sattelanhängers",
      trailerNumber_placeholder: "Sattelanhänger-Kennzeichen eingeben",
      registrationNumber: "Kennzeichen",
      registrationNumber_placeholder: "Kennzeichen eingeben",
      type: "Fahrzeugtyp",
      type_placeholder: "Fahrzeugtyp eingeben",
      add: "Fahrzeug hinzufügen",
      adding: "Fahrzeug wird hinzugefügt...",
      delete_complete: "Fahrzeug erfolgreich gelöscht",
      edit_complete: "Fahrzeug erfolgreich bearbeitet",
      add_complete: "Erfolgreich hinzugefügt",
      pick_car_type: "Fahrzeuguntertyp auswählen",
      go_to_cars: "Zu Fahrzeugen gehen",
      pick_department_to_add_car: "Abteilung auswählen",
    },
    add_samochod: {
      title: "Neues Fahrzeug hinzufügen",
      edit_title: "Fahrzeug bearbeiten",
      name: "Marke",
      name_placeholder: "Fahrzeugmarke eingeben",
      trailerNumber: "Kennzeichen des Sattelanhängers",
      trailerNumber_placeholder: "Sattelanhänger-Kennzeichen eingeben",
      registrationNumber: "Kennzeichen",
      registrationNumber_placeholder: "Kennzeichen eingeben",
      type: "Fahrzeugtyp",
      type_placeholder: "Fahrzeugtyp eingeben",
      add: "Fahrzeug hinzufügen",
      adding: "Fahrzeug wird hinzugefügt...",
      delete_complete: "Fahrzeug erfolgreich gelöscht",
      edit_complete: "Fahrzeug erfolgreich bearbeitet",
      add_complete: "Erfolgreich hinzugefügt",
      pick_department_to_add_car: "Abteilung auswählen",
    },
    add_solo_cars: {
      policy: "Versicherungspolice hinzufügen",
      title: "Neues Fahrzeug hinzufügen",
      edit_title: "Fahrzeug bearbeiten",
      name: "Marke",
      name_placeholder: "Fahrzeugmarke eingeben",
      vim: "VIN",
      vim_placeholder: "VIN eingeben",
      registrationNumber: "Kennzeichen",
      registrationNumber_placeholder: "Kennzeichen eingeben",
      add: "Fahrzeug hinzufügen",
      adding: "Fahrzeug wird hinzugefügt...",
      customName: "Benutzerdefinierter Name",
    },

    list_vehicles: {
      auta_solowe: "Solo-Fahrzeuge anzeigen für:",
      ciagniki_siodlowe: "Sattelzugmaschinen anzeigen für:",
      przyczepa: "Anhänger anzeigen für:",
      naczepa: "Sattelanhänger anzeigen für:",
      samochod: "Fahrzeuge anzeigen für:",
      all: "Alle Fahrzeuge anzeigen für:",
      custom: "Zeige {0} {1} für:",
      pick_department: "Abteilung auswählen",
    },
    list_auth: {
      accepted: "Akzeptierte Autorisierungen",
      pending: "Ausstehende Autorisierungen",
      company: {
        name: "Firmenname",
      },
      department: {
        count: "Anzahl der Abteilungen",
        count_d: "Anzahl der Lager",
        show: "Abteilungen",
        name: "Abteilungsname",
        empty_departments: "Sie sind keiner Abteilung zugeordnet",
      },
    },
    add_documents: {
      success: "Dokument wurde erfolgreich hinzugefügt. Bitte warten Sie auf die Verifizierung durch den Administrator.",
      file_uploaded: "Datei wurde erfolgreich hinzugefügt",
      add_file: "Neue Datei hinzufügen",
      title: "Neues Dokument hinzufügen",
      select: "Datei zum Hochladen auswählen (max. 10 MB)",
      desc: "Kurze Dokumentbeschreibung (max. 200 Zeichen)",
      visible: "Dokument für alle sichtbar (öffentlich)",
      choose_file: "Datei auswählen",
      choose_files: "Dateien auswählen",
      no_files_chosen: "Keine Datei ausgewählt",
      adding: "Dokument wird geladen...",
      add: "Dokument hinzufügen",
      file_size_error: "Datei zu groß",
      no_file_error: "Keine Datei hochgeladen.",
      no_access: "Sie haben keinen Zugriff auf diesen Dokumenttyp",
      file_type_error: "Ungeeignetes Dateiformat",
      delete_error: "Fehler beim Löschen des Bildes",
      accept_doc_confirm: "Sind Sie sicher, dass Sie das Dokument akzeptieren möchten?",
      reject_doc_confirm: "Sind Sie sicher, dass Sie das Dokument ablehnen möchten?",
    },
    calendar: {
      ramps: ramps,
      warehouse: "Lager",
      name: "Lagername",
      fill: "Kalender ausfüllen",
      fill_department_calendar: "Kalender erstellen",
      taken: "Belegt",
      time_windows: "Zeitfenster",
      slots: "Anzahl verfügbarer Slots",
      from: "Lager verfügbar von:",
      to: "Lager verfügbar bis:",
      delete: "Zeitfenster löschen",
      deleteAll: "Alle Zeitfenster löschen",
      deleteAllQuestion: "Möchten Sie alle Zeitfenster von diesem Tag löschen?",
      show_monitary: "Avisierungen anzeigen",
      monitary_id: "Avisierungs-ID",
      company_id: "Firmen-ID",
      worker_id: "Mitarbeiter-ID",
      give_additional_monitory_note_id: "Zusätzliche Avisierungs-ID vergeben (optional)",
      confirm_monitory_note_rejection: "Sind Sie sicher, dass Sie die Avisierung ablehnen möchten?",
      confirm_monitory_note_archive: "Sind Sie sicher, dass Sie die Avisierung beenden möchten?",
      confirm_authorization_rejection: "Sind Sie sicher, dass Sie die Autorisierung ablehnen möchten?",
      monitary_time: "Avisierungszeit",
      driver: "Fahrerdaten",
      wehicle: "Fahrzeugdaten",
      add: "Zeitfenster hinzufügen",
      enter_limit: "Limit für Be- und Entladungen pro Tag eingeben",
      you_can_add_more: "Sie können weitere Zeitfenster erstellen",
      creating: "Kalender wird erstellt",
      for_month: "Für den Monat:",
      weekday: "Wochentag",
      interval: "Länge des Zeitfensters",
      interval_short: "Intervall (Minuten)",
      block_monitary: "Keine Avisierungsmöglichkeit",
      limitless_monitary: "Unbegrenzte Avisierungsmöglichkeit",
      add_succes: "Kalender erfolgreich hinzugefügt",
      edit_succes: "Zeitfenster erfolgreich bearbeitet",
      add_error: "Fehler beim Hinzufügen des Kalenders",
      add_data_missing: "Fehlerhaft ausgefüllte Daten",
      limit: "Alle Limits für Be- und Entladungen müssen ausgefüllt sein.",
      empty_hours: "Stunden und Minuten der Zeitfenster dürfen nicht leer sein",
      empty_interval: "Die Länge des Zeitfensters darf nicht leer sein oder 0 Minuten dauern.",
      wrong_hours: "Die Stunden der Zeitfensterlänge sind falsch ausgefüllt.",
      same_hour_error: "Start- und Endzeit des Fensters müssen unterschiedlich sein.",
      fill_all_boxes: "Alle Felder ausfüllen",
      correctly_fill_all_boxes: "Alle Felder korrekt ausfüllen",
      create_calendar: "Kalender erstellen",
      monitory_note_calendar: "Avisierungskalender",
      emptyCalendar: "Kein Kalender für den angegebenen Monat",
      unlimited: "Unbegrenzte Be-/Entladungen",
      loadLimit: "Beladungslimit",
      unloadLimit: "Entladungslimit",
      enter_load_nr: "Anzahl der Ladungen eingeben",
      date_error: "Aktionen an Zeitfenstern vergangener Tage sind verboten",
      copyPreviousMonth: "Vorherigen Monat kopieren",
      calendarHint: "Um Ausfüllung bitten",
      errors: {
        startHour: "Fehlerhafte Öffnungszeit.",
        endHour: "Fehlerhafte Schließungszeit.",
        interval: "Fehlerhafte Fensterlänge.",
      },
    },
    document: {
      empty_company: "Alle hinzugefügten Dokumente werden in diesem Tab angezeigt",
      index: "Nr.",
      originalname: "Dateiname",
      description: "Dateibeschreibung",
      createdAt: "Hinzugefügt am",
      addedBy: "Hinzugefügt von",
      visible: "Sichtbar",
      action: "Aktion",
      title: "Dokumente",
      emoty_document_type: "Keine Dokumente",
    },
    stock: {
      loadingTime: "Zeit",
      my_cancelled_orders: "Stornierten Bestellungen",
      numberOfPilots: "Anzahl der Piloten",
      "pilot-offers": "Pilot-Angebote",
      numberOfNights: "Anzahl der Nächte",
      pricePerKm: "Preis pro Kilometer",
      minOfferAmount: "Mindestangebot",
      inactive: "Auktion inaktiv",
      license: "Lizenz",
      driver: "Spediteur",
      distanceInKm: "Entfernung in km",
      enter_auction_data: "Auftragsdaten eingeben",
      step2Title: "Details aller Ladungen ergänzen",
      add_auction: auction_adding,
      types: {
        auction: "Auktion",
        predetermined: "Zugewiesener Transport",
        group: "Für Gruppe",
        public: "Öffentlich",
      },
      add_order: {
        invalid_time_range: "Die Entladezeit muss später sein als die Beladezeit",
        end_time_reset_warning: "Die Entladezeit wurde zurückgesetzt, da sie früher als die Beladezeit war",
        end_time_after_start: "Entladedatum und -zeit müssen später sein als Beladedatum und -zeit",
        min_pilots: "Die Mindestanzahl der Piloten ist 1",
        end_date_after_start: "Das Enddatum muss nach dem Startdatum liegen",
        invalid_date_range: "Das Startdatum darf nicht nach dem Enddatum liegen",
        start_date_in_past: "Das Startdatum darf nicht in der Vergangenheit liegen",
        end_date_reset_warning: "Das Enddatum wurde automatisch zurückgesetzt, da es vor dem neuen Startdatum lag",
        from: "Ort und Datum der Verladung",
        to: "Ort und Datum der Entladung",
        license_requirements: "Anforderungen an Begleitfahrzeuge",
        pilots_count: "Anzahl der Begleitfahrzeuge",
        required_licenses: "Erforderliche Lizenz",
        max_pilots: "Maximale Anzahl der Begleitfahrzeuge ist 10",
        order_number: "Auftragsnummer",
        pick_currency: "Währung auswählen",
        length: "Länge",
        width: "Breite",
        height: "Höhe",
        dimension_error: "Ungültiger Wert",
        weight_error: "Ungültiger Wert",
      },
      signature: {
        loader: "Unterschrift Absender",
        carrier: "Unterschrift Empfänger",
        redo: "Erneut unterschreiben",
      },
      changelog: {
        numberofpilots: "Anzahl der Piloten",
        distanceinkm: "Entfernung (km)",
        license: "Lizenz",
        flatrate: "Pauschalsatz",
        cargodescription: "Ladungsbeschreibung",
        cargolength: "Ladungslänge",
        cargodocumentnumber: "Dokumentnummer",
        cargoremarks: "Zusätzliche Beschreibung",
        cargovolume: "Ladungsvolumen",
        cargoweight: "Ladungsgewicht",
        cargonumberofpallets: "Anzahl der Paletten",
        surcharge: "Zuschlag",
        surcharges: "Zuschlag",
        date: "Änderungen vom:",
        treshold: "Überbietungsschwelle",
        title: "Auktionsänderungsprotokoll",
        no_data: "Keine Änderungen im Protokoll",
        startingprice: "Mindestpreis",
        numberdeliveries: "Anzahl der Lieferungen",
        idloader: "ID Verlader",
        dateofloading: "Startdatum",
        dateofoperation: "Betriebsdatum",
        numberofitems: "Anzahl der Stücke",
        dateofunloading: "Entladungsdatum",
        deadline: "Ende",
        paymentdeadline: "Zahlungsfrist",
        numberofpallets: "Anzahl der Paletten",
        volume: "Volumen",
        weight: "Gewicht",
        deliveriesnumber: "Anzahl der Ladungen",
        documentnumber: "Dokumentnummer",
        description: "Beschreibung",
        length: "Länge",
        ordernumber: "Auftragsnummer",
        loadingcity: "Beladungsstadt",
        loadingcityzipcode: "Postleitzahl Beladung",
        loadingCountry: "Land Beladung",
        loadingcitycountry: "Land Beladung",
        unloadingcity: "Entladungsstadt",
        unloadingcityzipcode: "Postleitzahl Beladung",
        unloadingCountry: "Land Entladung",
        unloadingcitycountry: "Land Entladung",
        loadingweight: "Ladungsgewicht",
        loadingvolume: "Ladungsvolumen",
        loadinglength: "Ladungslänge",
        remarks: "Transportkommentar",
        currency: "Währung",
        ordertype: "Angebotstyp",
        cartype: "Fahrzeugtyp",
        loadingplace: "Beladungsort",
        unloadingplace: "Entladungsort",
        loadingplaceShort: "Laden",
        unloadingplaceShort: "Entladung",
        cityPlaceholder: "Stadt eingeben",
        additional: "Zusätzliche Inf.",
        maxLoadings: "Max. Anzahl Beladungen",
        maxUnloadings: "Max. Anzahl Entladungen",
        endDate: "Abschlusstermin",
      },
      transactions: {
        title: "Firmentransaktionsjournal",
        empty: "Keine Transaktionen für den angegebenen Zeitraum",
      },
      cant_add_offer: "Kein aktives Abonnement",
      buy_sub: "Abonnement kaufen",
      adding_offer: "Angebot abgeben",
      auto_offering: {
        title: "Mindestpreis / automatisches Überbieten",
        price: "Mindestpreis der Auktion:",
        enabled: "Automatisches Überbieten des Angebots ist eingestellt.",
        title_short: "Automatisches Überbieten des Angebots",
        min_price: "Mindestbetrag",
        save: "Änderungen speichern",
        no_offers: "Sie haben noch keine Angebote für diese Auktion abgegeben.",
      },
      car_part: "Art des Anhängers / Sattelanhängers",
      auction_number_short: "Auftragsnr.",
      part: "Anhänger / Sattelanhänger",
      load_warehouse: "Beladungslager",
      unload_warehouse: "Entladungslager",
      deadlineNoCounter: "Ende der Auktion",
      auction_details: "Auftragsdetails",
      do_you_want_offer: "Sind Sie sicher, dass Sie das Angebot annehmen möchten?",
      do_you_want_offer_reject: "Sind Sie sicher, dass Sie das Angebot ablehnen möchten?",
      document_error: "Sie können das Dokument nicht herunterladen",
      document_error_details: "Das Speditionsdokument ist für diesen Auftrag noch nicht verfügbar.",
      included_transactions: "Abgegebene Angebote",
      surcharges_to_transport: "Zuschläge zu Transporten",
      adding_ofer: "Angebot abgeben",
      added_files: "Hinzugefügte Dateien",
      no_files: "Keine Anhänge",
      loadingCountries: "Transportstart",
      informationAboutLoad: "Informationen über die Ladung",
      loadingDates: "Startdatum",
      unloadingCountries: "Transportende",
      unloadingDates: "Entladungsdaten",
      department_data: "Abteilungsdaten",
      department_name: "Abteilungsname",
      department_address: "Abteilungsadresse",
      offerType: "Angebotstyp",
      participantsNumber: "Anzahl der Teilnehmer",
      offer: "Angebot",
      priceFrom: "Berechneter Preis",
      bindingFrom: "Bindend von",
      bindingTo: "Bindend bis",
      given: "Angegeben",
      givenFrom: "Angegeben von",
      date: "Datum",
      loadingType: "Beladungstyp",
      loading: "Beladung",
      unloading: "Entladung",
      lowest_prices: "Niedrigste vorgeschlagene Preise",
      numberOfCargo: "Anzahl der Ladungen.",
      detailsOfCargo: "Ladungsdetails",
      companyName: "Firmenname",
      location: "Standort",
      loadingPoints: "Beladungseinheiten",
      loadingPlaces: "Einzelne Beladungsorte",
      price: "Preis",
      placeOfDisposal: "Dispositionsort",
      disposal: "Disponent",
      car: "Fahrzeug",
      nrTransport: "Transportinformationen",
      lastModifiedDate: "Datum der letzten Änderung",
      idTransporeon: "XLplanner-ID",
      idLogiPlanner: "XLplanner-ID",
      idShipper: "Verlader-ID",
      category: "Gewichtskategorie (kg)",
      shipperName: "Verladername",
      shipper: "Verlader",
      users: "Ausstellender Mitarbeiter",
      delivers: "Lieferungen (Anzahl Entladungen)",
      deliversLoads: "Lieferungen (Anzahl Beladungen)",
      cargos: "Anzahl der Ladungen",
      typeOfOrder: "Art des Auftrags",
      quot: "%Quote",
      loadingDate: "Startdatum",
      unloadlingDate: "Entladungsdatum",
      deadline: "Auktionsende",
      lastModification: "Datum der letzten Änderung",
      loadingCity: "Beladungsstadt",
      loadings: "Transportstart",
      unloadings: "Transportende",
      postCode: "Postleitzahl",
      country: "Land",
      unLoadingCity: "Entladungsstadt",
      carType: "Fahrzeugtyp",
      typeOfCar: "Fahrzeugart",
      currentAuctionPrice: "Aktueller Preis",
      deliverAmount: "Anzahl der Lieferungen",
      weight: "Beladungsgewicht",
      weightT: "Beladungsgewicht (t)",
      volumeM: "Beladungsvolumen (m³)",
      volume: "Volumen",
      length: "Beladungslänge",
      lengthM: "Beladungslänge (m)",
      remarks: "Bemerkungen",
      canceled_transports: "Stornierte Transporte",
      cancel_order: "Auftrag stornieren",
      end_order: "Auftrag beenden",
      orders_archive: "Auftragsarchiv",
      cancelled_orders: "Stornierte Aufträge",
      comment: "Transportkommentar",
      terms: "Vertragsbedingungen",
      selected_transports: "Zugewiesene Transporte",
      rejected_transports: "Nicht zugewiesene Transporte",
      no_won_auctions: "Keine gewonnenen Auktionen",
      no_selected_transports: "Keine zugewiesenen Transporte",
      no_canceled_transports: "Keine stornierten Transporte",
      no_selected_transports_lost: "Keine nicht zugewiesenen Transporte",
      unreceived_transports: "Nicht erhaltene Transporte",
      created_groups: "Erstellte Gruppen",
      extra_charges: "Zusatzkosten",
      startingPrice: "Mindestpreis",
      no_attachment: "Keine Anhänge",
      dateAndHour: "Wann hinzugefügt",
      offerSum: "Betrag",
      surchargeTitle: "Zusätzliche Kosten",
      status: "Status",
      my_offers: "Mein Angebot für diesen Auftrag",
      all_offers: "Alle Angebote bei dieser Auktion",
      no_offers: "Sie haben noch keine Angebote für diese Auktion abgegeben",
      my_waiting_offers: "Meine zugewiesenen Transporte aus Auktionen",
      offer_details: "Angebotsdetails",
      offer_placing_department: "Abteilung, von der das Angebot abgegeben wurde",
      offer_placing_user: "Benutzer, der das Angebot abgegeben hat",
      offer_removal_confirmation: "Sind Sie sicher, dass Sie das Angebot zurückziehen möchten?",
      which_auction: "Auktion, auf die sich das Angebot bezieht",
      company_placing_auction: "Verlader",
      additional_pays: "Zuschläge",
      winning_offer: "Gewinnerangebot",
      templateName: "Vorlagenname",
      nameTemplate: "Vorlage benennen",
      auction_removal: "Sind Sie sicher, dass Sie diesen Auftrag stornieren möchten?",
      loadReservation: "Beladungszeit reservieren",
      unloadReservation: "Entladungszeit reservieren",
      startPoint: "Startpunkt",
      endPoint: "Endpunkt",
      statuses: {
        assigned: "Zugewiesen",
        waiting_for_reservation: "Wartet auf Reservierung",
        waiting_for_payment: "Wartet auf Zahlung",
        reservation_sent: "Eingereicht",
        pending: "Ausstehend",
        outbid: "Überboten",
        accepted: "Angenommen",
        delivery_accepted: "Zugewiesen",
        delivery_canceled: "Storniert",
        delivery_rejected: "Nicht zugewiesen",
        reserved: "Reserviert",
        canceled: "Storniert",
        finished: "Beendet",
        cancelled: "Storniert",
        active: "Aktiv",
        rejected: "Abgelehnt",
        won: "Gewonnen",
        all: "Alle",
      },
      bid: {
        referencePrice: "Automatisches Überbieten",
        autoConquerUntill: "Bis zu welchem Betrag",
        takeReferencePrice: "Referenzpreis verwenden",
        type: "Angebotstyp",
        offer: "Angebot",
        price: "Berechneter Preis",
        dateRange: "Bindend bis",
        carId: "Fahrzeug auswählen",
        departmentId: "Abteilung",
        comment: "Angebotskommentar",
        commentPlaceholder: "Angebotskommentar - sichtbar für Spediteur und Verlader",
        submit: "Angebot abgeben",
        cancel: "Abbrechen",
        price_error: "Das Feld muss eine Dezimalzahl größer als Null mit maximal zwei Nachkommastellen sein.",
        capasity_error: "Das Feld muss eine Dezimalzahl größer als Null mit maximal zwei Nachkommastellen sein.",
        palletAndPiecesError: "Das Feld muss größer als Null mit maximal zwei Nachkommastellen sein.",
        maxValue: "Maximalwert ist:",
        full_number_error: "Das Feld muss eine ganze Zahl sein",
      },
      deliverInfo: {
        widthWord: "Breite",
        heightWord: "Höhe",
        loadingPlace: "Beladungsort",
        map: "Karte",
        weight: "Abmessungen und Gewichte",
        unloadingPlace: "Entladungsort",
        other: "Sonstige",
        deliver: "Lieferung",
        weightWord: "Gewicht",
        lengthWord: "Länge",
        capasityWord: "Volumen",
        surcharge: "Zuschlag",
        licenseType: "Lizenztyp",
      },
      contactDetails: {
        user_data: "Person, die den Auftrag ausstellt",
        user: "Kontaktperson",
        phone: "Tel",
        cell_phone: "Mobiltelefon",
      },
    },
    languages: {
      title: "Sprache der Anwendung ändern",
      current: "Aktuell ausgewählte Sprache:",
    },
    listing_departments: {
      title: "Liste der verfügbaren Lager",
      title_drivers: "Liste der verfügbaren Spediteure",
      authorize: "Autorisierungsanfrage senden",
      authorized: "Autorisiert",
    },
  },
  payments: {
    choose_payment_provider: "Wählen Sie Ihren Zahlungsanbieter",
    empty_wallet: {
      title: "Um eine Zahlung für die Avisierung zu tätigen, müssen Sie zuerst Ihr Wallet aufladen",
      under_title: "Wählen Sie eines der verfügbaren Zeitfensterpakete, um zur Zahlung zu gelangen:",
    },

    list: {
      status: "Transaktionsstatus",
      date: "Transaktionsdatum",
      doc: "Avisierungsdokument",
      department: "Spediteur",
      value: "Betrag",
      time_windows: "Gekaufte Fenster",
      company: "Unternehmen",
      invoice: "Rechnung",
      download: "Rechnung herunterladen",
      no_invoice: "Die Rechnung erscheint zu Monatsbeginn",
      history: "Transaktionshistorie",
      history_short: "Historie",
    },
    spelling: {
      window: "Zeitfenster",
      more_windows: "Zeitfenster",
      multiple_windows: "Zeitfenster",
      day: "Tag Abonnement",
      days: "Tage Abonnement",
    },
    number_of_users: "Anzahl der Benutzer",
    invoices: "Rechnungen",
    windows: "Zeitfenster",
    spent_windows: "Verbrauchte Fenster",
    returned_windows: "Zurückgegebene Fenster",
    days: "Abonnementtage",
    sub: "Abonnement",
    extend_sub: "Abonnement verlängern",
    buy_sub: "Abonnement kaufen",
    none: "Keine",
    no_active_sub: "Kein aktives Abonnement",
    subscription_end: "Abonnement aktiv bis",
    success: "Zahlung erfolgreich abgeschlossen",
    success_monitory: "Zahlung erfolgreich abgeschlossen. Avisierung bezahlt",
    confirmation: "Sind Sie sicher, dass Sie die Avisierung bestätigen und bezahlen möchten?",
    sum: "Aktueller Kontostand",
    sum_after: "Kontostand nach der Transaktion",
    currencyTime: "Anzahl der Zeitfenster",
    charge: "Konto aufladen",
    package_choice: "Aufladungspaket auswählen",
    sub_package: "Abonnementpakete",
    win_package: "Zeitfensterpakete",
    admin: {
      add: "Paket hinzufügen",
      edit: "Preisliste bearbeiten",
      info1: "Drücken Sie 'Paket hinzufügen', um ein neues Preispaket hinzuzufügen.",
      info2: "Um ein bestehendes Paket zu löschen, drücken Sie das X daneben.",
      price: "Preis",
      price_placeholder: "Paketpreis eingeben",
      monitoryNotesNumber: "Anzahl der Zeitfenster",
      monitoryNotesNumber_placeholder: "Anzahl der Zeitfenster eingeben",
      daysNumber: "Anzahl der Abonnementtage",
      description: "Zusätzliche Paketbeschreibung (optional)",
    },
    errors: {
      required: "Feld erforderlich",
      price: "Falscher Preis. Der Preis muss positiv und nur aus Ziffern bestehen. Dezimalstellen sollten durch einen Punkt getrennt werden",
      number: "Das Feld muss eine positive ganze Zahl sein.",
      monitoryNotesNumber: "Die Anzahl muss nur aus Ziffern bestehen",
      bad_payment: "Die Zahlung konnte nicht verarbeitet werden.",
      payment_too_long: "Die Zahlungsverarbeitung dauerte zu lange.",
    },
    currency: "ZŁ",
  },
  profile_settings: {
    settings: "Passwort ändern",
    password_change: "Passwort ändern",
    password_change_success: "Passwort erfolgreich geändert",
    current_password: "Aktuelles Passwort",
    current_password_placeholder: "Aktuelles Passwort eingeben",
    new_password: "Neues Passwort",
    new_password_placeholder: "Neues Passwort eingeben",
    confirm_password: "Passwort bestätigen",
    confirm_password_placeholder: "Passwort bestätigen",
    update_information: "Informationen aktualisieren",
    two_step_verification: "Zwei-Faktor-Authentifizierung",
    two_step_verification_desc: "Sichern Sie Ihr Konto zusätzlich mit einem zweiten Anmeldeschritt.",
    two_step_verification_active: "Aktiviert",
    two_step_verification_inactive: "Deaktiviert",
    select_verification_method: "Verifizierungsmethode auswählen",
    privacy_settings: "Privatsphäre-Einstellungen",
    receiving_notifications_about_forum_threads: "Ich möchte keine Benachrichtigungen über Forum-Threads erhalten",
    receiving_notifications_about_comments: "Ich möchte keine Benachrichtigungen über Kommentare zu meinen Inspirationen erhalten",
    commenting_user_projects_by_others: "Ich erlaube anderen Benutzern nicht, meine Inspirationen zu kommentieren",
    receiving_notifications_of_ratings_by_others: "Ich möchte keine Benachrichtigungen über meine Bewertung durch andere Benutzer erhalten",
    receiving_messages_from_others_users: "Ich möchte keine Nachrichten von anderen Portal-Benutzern erhalten (gilt nicht für Administrator)",
    profile_indexing: "Ich erlaube nicht die Indexierung meines Profils, Projekte, Inspirationen durch Suchmaschinen",
    add_user_request: "Möchten Sie die Einladung annehmen?",
    invitation_accepted: "Einladung wurde angenommen",
    invitation_rejected: "Einladung wurde abgelehnt",
    invitation_processed: "Einladung verarbeitet",
    click_to_go_to_main_page: "Klicken Sie, um zur Hauptseite zu gehen",
  },
  monitary_notes: {
    title: "Assistent für neue Avisierung",
    wrong_hours: "Fehlerhafte Fensterzeiten",
    step_one_title: "Auswahl von Art und Ort der Operation",
    step_one_two: "Auswahl von Datum und Uhrzeit der Bereitstellung",
    step_one_three: "Angabe von Informationen über die Ladung",
    operation: "Art der Operation",
    department: "Wählen Sie die Abteilung, von der aus Sie avisieren möchten.",
    warehouse: "Wählen Sie das Lager, bei dem Sie sich avisieren möchten",
    next: "Weiter",
    warehouse_chosen: "Ausgewähltes Lager",
    no_free_time_windows: "Keine freien Zeitfenster",
    hour: "Bereitstellungszeit auswählen",
    save: "Avisierung speichern",
    cargoType: "Ladungsart",
    weight: "Ladungsgewicht ",
    length: "Ladungslänge (m)",
    capacity: "Ladungsvolumen (m³)",
    numberOfPallets: "Anzahl der Paletten",
    numberOfPieces: "Anzahl der Stücke",
    numberOfDocument: "Dokumentnummer",
    identityDoc: "Ausweisdokumentnr.",
    driverEmail: "Fahrer-E-Mail",
    additionalDescription: "Zusätzliche Beschreibung",
    tractorNumber: "Zugmaschinen-Nummer",
    semitrailerNumber: "Sattelanhänger-Kennzeichen",
    name: "Vor- und Nachname des Fahrers",
    driverDocument: "Ausweisdokumentnummer des Fahrers",
    driverDocumentShort: "Ausweisdokumentnummer",
    driverPhone: "Telefonnummer des Fahrers",
    car_registration_number: "Fahrzeug-Kennzeichen",
    pick_car: "Fahrzeug auswählen",
    pick_trailor: "Anhänger auswählen (optional)",
    pick_semitrailor: "Sattelanhänger auswählen",
    monitary_note_added: "Avisierung hinzugefügt",
    status_changed: "Status geändert",
    monitary_notes_archive: "Avisierungsarchiv",
    car_status: "Fahrzeugstatus",
    monitary_note_changed: "Avisierung bearbeitet",
    monitory_notes_list: "Liste der Avisierungen für das angegebene Zeitfenster",
    empty_monitory_notes: "Keine Avisierungen",
    show_monitary_for: "Avisierungen anzeigen für",
    driver_came: "Fahrer ist angekommen",
    driver_didnt_come: "Kein Fahrer",
    confirm_adding: "Sind Sie sicher, dass Sie die Avisierung akzeptieren möchten?",
    load_details: "Ladungsdetails",
    load_number: "Ladung {0}.",
    monitary_modal: {
      description: "Art der Entladung",
      numberOfPallets: "Anzahl der Paletten",
      consignmentNumber: "Dokumentnummer",
      registrationNumber: "Fahrzeug-Kennzeichen",
      date: "Dokumentnummer",
      volume: "Ladungsvolumen (m³)",
      length: "Ladungslänge (m)",
      weight: "Ladungsgewicht",
      driverFullName: "Vor- und Nachname des Fahrers",
      driverPhone: "Telefonnummer des Fahrers",
      driverEmail: "E-Mail des Fahrers",
      driverDocument: "Ausweisdokumentnr. des Fahrers",
      additionalDescription: "Zusätzliche Informationen",
      carId: "Fahrzeug-Kennzeichen",
      semitralerId: "Anhänger-Kennzeichen",
      semitrailerNumber: "Anhänger-Kennzeichen",
      trailerNumber: "Sattelanhänger-Kennzeichen",
      tralerId: "Sattelanhänger-Kennzeichen",
      remarks: "Zusätzliche Informationen",
    },
    errors: {
      no_hour: "Bereitstellungszeit markieren",
    },
  },
  auction_adding: {
    location_placeholder_flexible: "Stadt oder genaue Adresse eingeben",
    location_hint: "Sie können nur eine Stadt (z.B. Berlin) oder eine vollständige Adresse (z.B. Alexanderplatz 1, Berlin) eingeben",
    city_location: "Stadt",
    address_location: "Genaue Adresse",
    location_incomplete: "Bitte wählen Sie einen Standort aus der Vorschlagsliste",
    no_licenses_title: "Keine zugewiesenen Lizenzen",
    no_licenses_description:
      "Du kannst kein Pilotenangebot hinzufügen, da deinem Unternehmensprofil keine Lizenzen zugewiesen sind. Um fortzufahren, musst du zuerst Lizenzen zu deinem Unternehmensprofil hinzufügen.",
    add_licenses_title: "Lizenzen zum Profil hinzufügen",
    add_licenses_description: "Wähle die Lizenzen aus, die du dem Profil deines Unternehmens hinzufügen möchtest:",
    add_licenses: "Lizenzen hinzufügen",
    licenses_added_success: "Lizenzen erfolgreich hinzugefügt",
    archive_empty: "Keine Aufträge im Archiv",
    delete_offer_confirmation: "Sind Sie sicher, dass Sie dieses Angebot löschen möchten?",
    no_offers_added: "Keine Angebote abgegeben",
    no_transactions_included: "Du hast keine Angebote für Aufträge erstellt",
    start_bid: "Aufträge suchen",
    update: "Aktualisieren",
    "pilot-offer-title": "Pilotenangebot hinzufügen",
    location: "Standort",
    location_placeholder: "Adresse eingeben...",
    location_required: "Standort ist erforderlich",
    selected_location: "Ausgewählter Standort",
    country: "Land",
    city: "Stadt",
    zip_code: "Postleitzahl",
    street: "Straße",
    start_date: "Startdatum",
    end_date: "Enddatum",
    max_radius: "Maximaler Radius zum Start",
    max_radius_placeholder: "Maximalen Radius eingeben...",
    select_licenses: "Lizenzen auswählen",
    select_licenses_description: "Markieren Sie die Lizenzen, die Sie für dieses Angebot nutzen möchten",
    license_required: "Mindestens eine Lizenz auswählen",
    submit: "Speichern",
    start_date_required: "Startdatum ist erforderlich",
    end_date_required: "Enddatum ist erforderlich",
    end_date_after_start: "Das Enddatum muss nach dem Startdatum liegen",
    radius_integer: "Der Wert muss eine ganze Zahl sein",
    radius_min: "Minimalwert ist 1",
    radius_max: "Maximalwert ist 999999",
    radius_required: "Maximaler Radius ist erforderlich",
    radius_number: "Der Wert muss eine Zahl sein",
    download_document: "Speditionsdokument herunterladen",
    title: "Auktion hinzufügen",
    startingPrice: "Mindestpreis",
    numberDeliveries: "Lieferungen (Anzahl Entladungen)",
    numberOfLoadings: "Lieferungen (Anzahl Beladungen)",
    dateOfLoading: "Startdatum",
    dateOfUnloading: "Entladungsdatum",
    deadline: "Auktionsende",
    loadingCity: "Beladungsstadt",
    loadingCityZipCode: "Postleitzahl Beladung",
    loadingCountry: "Land Beladung",
    unloadingCity: "Entladungsstadt",
    unloadingCityZipCode: "Postleitzahl Entladung",
    unloadingCountry: "Land Entladung",
    loadingAddress: "Beladungsadresse",
    unloadingAddress: "Entladungsadresse",
    loadingWeight: "Ladungsgewicht",
    loadingVolume: "Ladungsvolumen",
    loadingLength: "Ladungslänge",
    currency: "Auktionswährung",
    currency_short: "Währung",
    for_day: "Für den Tag",
    calc: "Rechner",
    hide: "Verbergen",
    rest_of_currencies: "Weitere Währungen",
    carType: "Fahrzeugtyp",
    carPart: "Anhänger-/Sattelanhängertyp",
    departmentLoaderId: "Ausstellende Abteilung",
    recipients: "Empfänger",
    remarks: "Zusätzliche Informationen",
    save: "Auftrag hinzufügen",
    surcharge: "Zuschlag (optional):",
  },
  tableData: tableDetails,
  validate: {
    email: "Die angegebene E-Mail ist ungültig",
    required: "Das Feld ist erforderlich",
    empty: "Das Feld darf nicht leer sein.",
    wrong_city: "Falscher Stadtname",
    password: "Das Passwort sollte enthalten: min. 8 Zeichen, min. 1 Großbuchstabe, min. 1 Kleinbuchstabe, min. 1 Zahl",
    passwordConfirmation: "Die Passwörter müssen identisch sein",
    min_number: "Der Wert muss größer als {number} sein",
  },
  error_codes: {
    "000": "Benutzer existiert nicht",
    "001": "Ungültige Anmeldedaten",
    "002": "Die angegebene E-Mail existiert bereits im System",
    "003": "Ungültiger Token",
    "004": "Ungültige Anfrage",
    "005": "Benutzer ist bereits über die Google-Plattform registriert",
    "006": "Benutzer ist bereits über die Facebook-Plattform registriert",
    "007": "Ungültiger Verifizierungscode",
    "008": "Warenkorb nicht gefunden",
    "009": "Konto nicht verifiziert. E-Mail mit Code wurde gesendet.",
    "010": "Produkt wurde bereits zu Favoriten hinzugefügt",
    "011": "Objekt existiert bereits",
    "012": "Falsches Passwort",
    "013": "@TODO CODE ZU ERGÄNZEN",
    "014": "An die angegebene E-Mail-Adresse wurde bereits eine Einladung gesendet",
    401: "Keine Autorisierung",
    403: "Keine Berechtigung zur Ausführung dieser Aktion",
    404: "Objekt nicht gefunden",
    default: "Bei der Verarbeitung der Anfrage ist ein Fehler aufgetreten.",
  },
  verification: {
    title: "Kontoverifizierung",
    in_progress: "Bitte haben Sie Geduld, Verifizierung läuft...",
    success: "Das Konto wurde verifiziert. Sie können sich anmelden.",
    error_during_verification: "Bei der Verifizierung ist ein Fehler aufgetreten. Stellen Sie sicher, dass der Link korrekt ist.",
  },

  page_not_found: {
    desc: "Leider wurde die gesuchte Seite nicht gefunden. Überprüfen Sie, ob Sie die richtige Adresse eingegeben haben.",
    back: "Zurück zur Hauptseite",
  },
  alert: {
    successfully_saved_data: "Daten erfolgreich gespeichert",
    successfully_updated_data: "Daten erfolgreich aktualisiert",
    error_during_saving_data: "Fehler beim Speichern der Daten",
    error_during_updating_data: "Fehler beim Aktualisieren der Daten",
  },
  menu: {
    auctionsDashboard: "Börsen-Dashboard",
    "add-offer": "Angebot hinzufügen",
    "my-offers": "Meine Angebote",
    "pilot-bid": "Pilotenbörse",
    price: "Preisliste",
    adverts: "Werbung",
    mass_message: "Gruppennachricht",
    admin_chat: "Chats mit Administrator",
    user_chat: "Benutzerchats",
    chat: "Nachrichten",
    language: "Sprache",
    widgets: "Widgets",
    dashboard: "Dashboard",
    my_company: "Unternehmen",
    my_profile: "Mein Profil",
    my_drivers: "Fahrer",
    my_warehouses: "Meine Abteilungen",
    my_warehouses_outside: "Externe Lager",
    list_warehouses: "Lagerliste",
    my_factories: "Meine Lager",
    my_cars: "Meine Fahrzeuge",
    time_windows: "Zeitfenster",
    monitory_notes: "Avisierungen",
    authorizations: "Autorisierungen",
    archive: "Archiv",
    calendar: "Kalender",
    settings: "Einstellungen",
    raports: "Berichte",
    loads: "Frachten",
    tenders: "Ausschreibungen",
    workers: "Mitarbeiter",
    documents: "Dokumente",
    warehouses: "Abteilungen",
    contracts: "Aufträge",
    subscription: "Abonnement",
    subscriptions: "Abonnement",
    warehouseList: "Lagerliste",
    warehouse_menagers: "Mitarbeiter im Lager",
    department_menagers: "Mitarbeiter in der Abteilung",
    admin_panel: "Administratorpanel",
    change_company: "Aktives Unternehmen wechseln",
    logout: "Abmelden",
    your_companies: "Ihre Unternehmen",
    companies: "Unternehmen",
    timeWindow: "Zeitfenster",
    bid: "Börse",
    bank: "Bank",
    invoices: "Zahlungsliste",
    drivers: "Spediteure",
    drivers_groups: "Pilotengruppen",
    drivers_list: "Spediteursiste",
    job_list: "Auftragsliste",
    factoring_list: "Factoring-Liste",
    participants_list: "Teilnehmerliste",
    insurances: "Versicherungen",
    auctions: "Börse",
    offers: "Angebote",
    lack_of_other_companies: "Keine anderen Unternehmen",
    return: "Zurück",
    help: "Hilfe",
    chat_with_admin: "Mit Admin chatten",
    pickCompanyToConnect: "Wählen Sie aus der Dropdown-Liste das Unternehmen, zu dem Sie wechseln möchten.",
    auctionPayment: "Provision von Auktionen",
    verificationPayments: "Verifizierungsüberweisungen",
    admin: {
      users: "Benutzer",
      users_logiplanner: "XLplanner",
      company: "Unternehmensdaten",
    },
  },
  admin: {
    general: {
      back: "Zurück",
      button_update_data_title: "Informationen aktualisieren",
      add: "+Mitarbeiter hinzufügen",
    },
    dashboard: {
      pilots: "Piloten",
      companies: "Registrierte Unternehmen",
      carriers: "Spediteure",
      factories: "Hersteller",
      warehouses: "Lager",
      waitingCompanies: "Wartende",
      value: "Gesamt",
      blocked: "Blockiert",
      waiting_for_acceptance: "Wartend",
      activated: "Akzeptiert",
    },

    profile: {
      my_profile_title: "Mein Profil",
      my_profile_settings_title: "Einstellungen",
      personal_image: "Hauptbild",
      update_success: "Daten erfolgreich aktualisiert",
      img_update_success: "Bild erfolgreich aktualisiert",
      img_delete_success: "Bild erfolgreich gelöscht",
      showGallery: "Galerie anzeigen",
      address_title: "Adresse",
      department_phone: "Kontakt",
      department_email: "E-Mail-Adresse",
      name: "Vorname",
      enter_name: "Vorname eingeben",
      surname: "Nachname",
      enter_surname: "Nachname eingeben",
      email: "E-Mail",
      enter_email: "E-Mail eingeben",
      phone_number: "Telefonnummer",
      enter_phone_number: "Telefonnummer eingeben",
      street: "Straße",
      enter_street: "Straße eingeben",
      premises_number: "Hausnummer",
      enter_premises_number: "Hausnummer eingeben",
      apartment_number: "Wohnungsnummer",
      enter_apartment_number: "Wohnungsnummer eingeben",
      zip_code: "Postleitzahl",
      enter_zip_code: "Postleitzahl eingeben",
      city: "Stadt",
      enter_city: "Stadt eingeben",
      validation: {
        zip_code: "Ungültige Postleitzahl. Min. Anzahl von Zeichen ist 3. Max. Anzahl von Zeichen ist 10.",
      },
      update_data_success: "Profildaten erfolgreich aktualisiert",
      update_profile_img: {
        alert_success: "Profilbild erfolgreich aktualisiert",
      },
      delete_profile_img: {
        alert_success: "Profilbild erfolgreich gelöscht",
      },
      settings: {
        back: "Zurück",
        my_profile: "Mein Profil",
        settings: "Einstellungen",
        manage_account: "Ihr Konto verwalten",
        change_default: "Standard-Factoring-Provision ändern",
        set_provision: "Factoring-Provision:",
        change_provision: "Provision ändern",
        change_password: "Passwort ändern",
        close_dialog: "Schließen",
        changing_password: "Passwort ändern",
        old_password: "Altes Passwort",
        old_password_placeholder: "Altes Passwort eingeben",
        new_password: "Neues Passwort",
        new_password_placeholder: "Neues Passwort eingeben",
        confirm_password: "Neues Passwort bestätigen",
        cancel: "Abbrechen",
        save: "Speichern",
        yes: "Ja",
        no: "Nein",
        saving_changes_confirmation: "Sind Sie sicher, dass Sie die Änderungen speichern möchten?",
        update_data_success: "Daten erfolgreich aktualisiert",
      },
    },
    users: {
      logiplanner: {
        title: "XLplanner",
        add_user: "Benutzer hinzufügen",
        firstname: "Vorname",
        surname: "Nachname",
        function: "Funktion",
        email: "E-Mail",
        phone: "Telefon",
        change_user_data: "Benutzerdaten und -berechtigungen ändern",
        access_blocked: "Zugriff für diesen Benutzer ist blockiert, klicken Sie, um den Zugriff zu entsperren",
        delete_user: "Benutzer löschen",
        loading: "Laden...",
        status_changed: "Status erfolgreich geändert",
        empty_users: "Keine Benutzer",
        show_docs: "Dokumente",
        show_workers: "Abteilungen",
        show_gallery: "Firmengalerie ansehen",
        add_user_modal: {
          dialog_close: "Schließen",
          edit_data: "Benutzerdaten bearbeiten",
          firstname: "Vorname",
          firstname_placeholder: "Vorname eingeben",
          email: "E-Mail",
          email_placeholder: "E-Mail eingeben",
          surname: "Nachname",
          surname_placeholder: "Nachname eingeben",
          phone: "Telefon",
          phone_placeholder: "Telefon eingeben",
          cancel: "Abbrechen",
          save: "Speichern",
          saving: "Speichern...",
        },
      },
    },
  },

  delete_client_modal: {
    dialog_close: "Schließen",
    deleting_client: "Kunde löschen",
    deleting_client_confirmation: "Sind Sie sicher, dass Sie den Kunden löschen möchten",
    cancel: "Abbrechen",
    delete: "Löschen",
    deleting: "Löschen...",
    deleting_success: "Kunde erfolgreich gelöscht",
    settings: "Zu Einstellungen gehen",
  },
  months: {
    JAN: "Januar",
    FEB: "Februar",
    MAR: "März",
    APR: "April",
    MAY: "Mai",
    JUN: "Juni",
    JUL: "Juli",
    AUG: "August",
    SEP: "September",
    OCT: "Oktober",
    NOV: "November",
    DEC: "Dezember",
  },
  days: {
    MON: "Montag",
    TUE: "Dienstag",
    WEN: "Mittwoch",
    THUR: "Donnerstag",
    FRI: "Freitag",
    SAT: "Samstag",
    SUN: "Sonntag",
  },
  generals: generals,
  ratings: ratings,
  widgetsTitles: widgets,
  addings: {
    adding: "Hinzufügen",
    worker: "Mitarbeiter hinzufügen",
    docs: "Dokumente hinzufügen",
    department: "Abteilung hinzufügen",
    warehouse: "Lager hinzufügen",
    monitary: "Avisierung hinzufügen",
    driver: "Spediteur hinzufügen",
    job: "Auftrag hinzufügen",
    auctions: "Meine Börse",
    adding_documents: "Dokumente hinzufügen",
    add_warehouse_menagers: "Weitere Mitarbeiter",
    add_department_menagers: "Weitere Mitarbeiter",
    hint: "Auftragsnr. oder Firmen-/Abteilungsname eingeben",
    add_attachment: "Anhang hinzufügen",
    doc: "Dokument hinzufügen",
    car: "Fahrzeug hinzufügen",
    group: "Gruppe hinzufügen",
    show_participants_for: "Teilnehmer für Auktion anzeigen:",
    auction: "Auftrag hinzufügen",
    add_to_group: "Zur Gruppe hinzufügen",
    driver_person: "Fahrer hinzufügen",
  },
  removings: {
    remove_documnet_question: "Sind Sie sicher, dass Sie das Dokument löschen möchten?",
    remove_warehouse_question: "Sind Sie sicher, dass Sie das Lager löschen möchten?",
    remove_admin_question: "Sind Sie sicher, dass Sie diesen Admin löschen möchten?",
    remove_worker_question: "Mitarbeiter bearbeiten",
    block_worker_question: "Sind Sie sicher, dass Sie den Mitarbeiter blockieren möchten?",
    unblock_worker_question: "Sind Sie sicher, dass Sie den Mitarbeiter entsperren möchten?",
  },
  missings: {
    auctions_canceled: "Keine stornierten Auktionen",
    drivers: "Keine Fahrer",
    form: "Das Formular ist fehlerhaft ausgefüllt. Füllen Sie die erforderlichen Felder aus und überprüfen Sie deren Richtigkeit.",
    departments: "Keine Abteilungen im Unternehmen",
    department_info: "Um die volle Funktionalität der Anwendung zu nutzen, müssen Sie mindestens eine Abteilung haben.",
    warehouse_info: "Um die volle Funktionalität der Anwendung zu nutzen, müssen Sie mindestens ein Lager haben.",
    department_info_worker: "Um die volle Funktionalität der Anwendung zu nutzen, müssen Sie mindestens einer Abteilung zugeordnet sein.",
    warehouse_info_worker: "Um die volle Funktionalität der Anwendung zu nutzen, müssen Sie mindestens einem Lager zugeordnet sein.",
    insurances: "Versicherungen können zu Fahrzeugen hinzugefügt werden, gehen Sie zum Tab 'Meine Fahrzeuge' und fügen Sie das erste Fahrzeug hinzu",
    results: "Keine Ergebnisse für die angegebenen Suchkategorien",
    no_contract: "Keine Vertragsbedingungen",
    no_remarks: "Keine zusätzlichen Informationen",
    no_car_statuses: "Fahrzeugstatus werden nach Hinzufügung des ersten Fahrzeugs angezeigt",
    auction_finished: "Die Auktion ist nicht mehr aktiv",
    no_subscription: "Sie haben kein Abonnement erworben",
    no_cars: "Sie haben nicht den entsprechenden Fahrzeugtyp",
    notifications: "Keine Benachrichtigungen",
    invoices: "Keine Rechnungen",
    invoicesMonthly: "Keine Monatsrechnungen",
    groups: "Alle erstellten Gruppen werden in dieser Liste angezeigt",
    auctions: "Keine ausgestellten Auktionen",
    participants: "Keine Auktionsteilnehmer",
    missing_department: "Wählen Sie die Abteilung, der Sie den Mitarbeiter zuordnen möchten.",
    missing_department_driver: "Wählen Sie die Abteilung, der Sie den Fahrer zuordnen möchten.",
    missing_role: "Wählen Sie die Mitarbeiterrolle.",
    enter_custom_name: "Geben Sie einen benutzerdefinierten Fahrzeugnamen ein.",
    no_authorized_warehouse:
      "Sie haben noch keine autorisierten Lager. Gehen Sie zur Lagerliste im Tab Zeitfenster, um die erste Autorisierung zu erstellen",
    no_vehicle: "Keine Fahrzeuge",
    no_vehicle_add: "Fahrzeug hinzufügen, um Avisierung durchzuführen",
    driver: "Keine Fahrer in der angegebenen Abteilung.",
    limit_reached:
      "Entschuldigung, aber der von Ihnen gewählte Tag hat das Limit für Avisierungen erreicht. Wählen Sie einen anderen Tag, um den Avisierungsvorgang abzuschließen.",
    taken_window:
      "Entschuldigung, aber das von Ihnen gewählte Zeitfenster wurde belegt. Wählen Sie ein anderes Zeitfenster, um den Avisierungsvorgang abzuschließen.",
  },
  system: {
    system: "System",
    blocked: "Blockiert",
    version: "Systemversion",
    client: "Kundennummer",
    company_name: "Firmenname",
    name_surname: "Vor- und Nachname",
    operating_system: "Betriebssystem",
    browser_version: "Browser-Version",
    browser_language: "Browser-Sprache",
    date: "Datum",
  },
  car_types: {
    solo_cars: "Einzelfahrzeug",
    naczepa: "Sattelauflieger",
    auta_solowe: "Einzelfahrzeug",
    dluzyca_przyczepa: "Langanhänger",
    tractor: "Sattelzugmaschine",
    ciagniki_siodlowe: "Sattelzugmaschine",
    tandem: "Tandem",
    solo_car: "Einzelfahrzeug",
    plain_tractor: "Zugmaschine",
    furgon: "Transporter",
    niskopodwoziowy_przyczepa: "Tiefbett (Anhänger)",
    autolaweta_laweta: "Autotransporter/Anhänger",
    wywrotka: "Kipper",
    hakowiec: "Abrollkipper",
    walkingfloor: "Kipper Walkingfloor",
    custom: "Sonderfahrzeug",
    custom_short: "Sonderfahrzeug",
    bdf_system_przyczepa: "BDF System",
    bdf_system_naczepa: "BDF System",
    izoterma: "Isolierfahrzeug",
    cysterna_chemiczna: "Chemietankwagen",
    cysterna_paliwowa: "Kraftstofftankwagen",
    cysterna_gazowa: "Gastankwagen",
    chlodnia: "Kühlfahrzeug",
    platforma: "Plattform",
    przyczepa: "Anhänger",
    plandeks_firanka: "Plane/Gardine",
    plandeka_firanka: "Plane/Gardine",
    dluzyca: "Langanhänger",
    plandeka_bde: "Plane BDE",
    plandeka_coilmulde: "Plane Coilmulde",
    plandeka_joloda: "Plane Joloda",
    plandeka_jumbo: "Plane Jumbo",
    plandeka_mega: "Plane Mega",
    plandeka_standard: "Plane Standard",
    sztywna_zabudowa: "Fester Aufbau",
    sztywna_zabudowa_skrzynia: "Fester Aufbau Koffer",
    chlodnia_hakowka: "Kühlfahrzeug Hakenlift",
    cysterna_inna: "Sonstiger Tankwagen",
    cysterna_silos: "Silo-Tankwagen",
    cysterna_spożywcza: "Lebensmitteltankwagen",
    podkontenerowa_20_cysterna: "Containeranhänger 20' Tankwagen",
    podkontenerowa_40_cysterna: "Containeranhänger 40' Tankwagen",
    podkontenerowa_20_standard: "Containeranhänger 20' Standard",
    podkontenerowa_40_standard: "Containeranhänger 40' Standard",
    podkontenerowa_45_standard: "Containeranhänger 45' Standard",
    podkontenerowa_swapbody: "Containeranhänger Wechselbrücke",
    niskopodwoziowy: "Tiefbett",
  },
  document_types: {
    all: "Alle",
    file: "Sonstige",
    nip: "Steuernummer",
    regon: "REGON",
    krs_cdig: "Handelsregister",
    transport_license: "(Transportlizenz)",
    carrier_insurance: "(Spediteurversicherung)",
    license: "Lizenz",
    insurance: "Versicherung",
    policy: "Police",
    agreements: "Vertragsbedingungen",
    car_license: "Fahrzeugzulassung",
    worker_license: "Begleiterlizenz",
  },
  statuses: {
    waiting: "Wartend",
    rejected: "Abgelehnt",
    accepted: "Akzeptiert",
    retreated: "Zurückgezogen",
    isWaiting: "Wartet",
    accepted_leasings: "Angenommene Anträge",
    waiting_leasings: "Eingereichte Anträge",
    rejected_leasings: "Abgelehnte Anträge",
    multiple_accepted: "Akzeptiert",
    multiple_approved: "Angenommen",
    all: "Alle",
    read: "Gelesen",
    unread: "Ungelesen",
    paid: "Bezahlt",
    canceled: "Storniert",
    initialized: "Begonnen",
    all_multiple: "Alle",
    confirmed: "Bestätigt",
  },
  authorizations: {
    no_department: "Keine Filialen",
    no_warehouse: "Keine Lager",
    add_department: "Filiale hinzufügen",
    add_warehouse: "Lager hinzufügen",
    cant_authorize_warehouse: "Um sich autorisieren zu können, müssen Sie mindestens ein Lager haben",
    cant_authorize_department: "Um sich autorisieren zu können, müssen Sie mindestens eine Filiale haben",
    cant_monitary_warehouse: "Um Termine vereinbaren zu können, müssen Sie mindestens ein Lager haben",
    cant_monitary_department: "Um Termine vereinbaren zu können, müssen Sie mindestens eine Filiale haben",
    pending: "Liste wartender Autorisierungen",
    to_fill_calendar: "Um den Kalender zu füllen, müssen Sie mindestens ein Lager haben",
    all: "Liste aller Autorisierungen",
    show_pending: "Wartende Autorisierungen anzeigen",
    show_all: "Alle Autorisierungen anzeigen",
    authorization_request_send: "Autorisierungsanfrage gesendet",
    authorization_success: "Erfolgreich autorisiert",
    authorization_rejected: "Autorisierung abgelehnt",
    authorization_error: "Keine Autorisierung",
    authorization_status: "Autorisierungsstatus",
    authorized: "Autorisiert",
    waiting: "Warten auf Bestätigung",
    rejected: "Abgelehnt",
    show_authorizations_for: "Autorisierungen anzeigen für",
    show_agreements_for: "Vertragsbedingungen anzeigen für",
    show_statuses_for: "Fahrzeugstatus anzeigen für",
    pick_department_to_authorization_w: "Wählen Sie das Lager aus, das Sie mit dem Spediteur autorisieren möchten",
    pick_department_to_authorization_d: "Wählen Sie die Filiale aus, die Sie mit dem Lager autorisieren möchten",
    show_details: "Details anzeigen",
    retreat: "Sind Sie sicher, dass Sie die Autorisierung zurückziehen möchten?",
    accept: "Sind Sie sicher, dass Sie die Autorisierung akzeptieren möchten?",
    reject: "Sind Sie sicher, dass Sie die Autorisierung ablehnen möchten?",
  },
  auctions: {
    cancled_auctions: "Stornierte Aufträge",
    waiting_auctions: "Zugewiesene Aufträge",
    listed_auctions: "Ausgeschriebene Aufträge",
    selected_auctions: "Zugewiesene Aufträge",
    current_auctions: "Teilnehmende Aufträge",
    my_transactions: "Teilnehmende Aufträge",
    my_auctions: "Meine Aufträge",
    all_auctions: "Alle",
  },
  demand: {
    accept_demand: "Anfrage akzeptieren",
    reject_demand: "Anfrage ablehnen",
    cancel_demand: "Anfrage stornieren",
    send_demand: "Anfrage senden",
  },
  bank: {
    bank: "Bank",
    loan: "Kredit",
    leasing: "Leasing",
    factoring: "Factoring",
  },
  vehicle_alerts: {
    delete_vehicle_question: "Sind Sie sicher, dass Sie das Fahrzeug löschen möchten?",
    no_vehicles_for_category: "Fügen Sie Fahrzeuge zur jeweiligen Kategorie hinzu, diese werden im entsprechenden Tab angezeigt.",
  },
  archive: {
    show_archive_for: "Archiv anzeigen für",
  },
  filters: {
    clear_filters: "Filter löschen",
    search: "Suchen",
    selected: "auserwählte",
    sort: "Sortieren nach",
    filter_by: "Filtern nach",
    search_by: "Suchen nach",
    no_sorting: "Keine Sortierung",
    alph_driver: "Alphabetisch (nach Spediteurname)",
    alph_warehouse: "Alphabetisch (nach Lagername)",
    alph_asc: "Alphabetisch A-Z (nach Name)",
    alph_desc: "Alphabetisch Z-A (nach Name)",
    newest: "Zuerst erstellt",
    oldest: "Zuletzt erstellt",
    id_asc: "ID (aufsteigend)",
    id_desc: "ID (absteigend)",
    id_warehouse_asc: "Lager-Auftragsnr. (aufsteigend)",
    id_warehouse_desc: "Lager-Auftragsnr. (absteigend)",
    radius: "Radius (in Kilometern)",
    document_search: "Dokumentname eingeben",
    car_search: "Fahrzeugname eingeben",
    department_search: "Nach Name suchen",
    worker_search: "Vor- oder Nachname des Mitarbeiters eingeben",
    driver_search: "Vor- oder Nachname des Fahrers eingeben",
    leasing_search: "Firmenname oder Telefonnummer eingeben, um Antrag zu suchen.",
    auction_search: "Steuernummer, Firmen-ID oder Auktions-ID eingeben, um Auktion zu suchen.",
    chats_search: "Filialname eingeben, um Chat zu suchen.",
    chats_search2: "Filialname, Firmensteuernummer oder Avisierungsnummer eingeben, um Chat zu suchen.",
    by_department: "Filialname, Filial-E-Mail, Firmenname oder Firmensteuernummer eingeben.",
    company_search: "Steuernummer, Firmen-ID oder Firmenname eingeben.",
    company_search_detailed: "Steuernummer, ID oder Name der gesuchten Firma eingeben",
    user_search: "ID, E-Mail, Vor- oder Nachname des Benutzers eingeben.",
    invoice: "Firmenname eingeben, um Rechnung zu suchen.",
    docs: "Firmenname eingeben, um Dokument zu suchen.",
    raports: "ID, Name oder Steuernummer der gesuchten Filiale/Firma eingeben.",
    auctions: "ID, Name oder Steuernummer eingeben",
    auctions_detailed: "ID, Name, Firmensteuernummer oder Auktions-ID eingeben, um Auktion zu suchen",
    show_drivers_for: "Fahrer anzeigen für",
    auctions_by_id: "Auktions-ID eingeben, um Auktion zu suchen",
    auctions_by_id_short: "Auktions-ID eingeben",
  },
  languages: {
    pl: "Polnisch",
    en: "Englisch",
    de: "Deutsch",
  },
  widgets: {
    authorization_widget: "Autorisierungs-Widgets",
    currency_widget: "Wechselkurs-Widget",
    map: "Funktionalitätskarte",
    cars: "Fahrzeugstatus",
    error: "Fehler beim Aktualisieren der Widgets",
    success: "Widgets erfolgreich aktualisiert",
    nbp_currencies: "Durchschnittskurs der Nationalbank",
    available: "Verfügbare Dashboard-Widgets",
    currency: "Wechselkurse",
    monitory: "Avisierungskalender",
    functionality_map: "Funktionalitätskarte",
    my_cars: "Meine Fahrzeuge",
    drivers: "Fahrerliste",
    advertisement: "Werbung",
    user_departments: "Meine Filialen",
    documents: "Dokumente",
    workers: "Mitarbeiter",
    company: "Firma",
    carrier_groups: "Meine Gruppen",
    user_external_warehouses: "Externe Lager",
    user_warehouses: "Lagerliste",
    monitory_notes_archive: "Avisierungsarchiv",
    warehouses_list: "Meine Lager",
    authorizations: "Autorisierungen",
    monitory_notes: "Avisierungen",
    car_statuses: "Fahrzeugstatus",
    participants_list: "Auktionsmitglieder",
    auctions_archive: "Auktionsarchiv",
    created_groups: "Erstellte Gruppen",
    auctions: "Börse",
    invoices: "Rechnungen",
    subscription: "Abonnement",
    time_windows: "Zeitfenster",
    leasing: "Leasing",
    factoring: "Factoring",
    surcharges: "Zuschläge",
    transports: "Transporte",
  },
  phone_verifications: {
    title: "Sie haben eine nicht verifizierte Telefonnummer",
    user: "Benutzer",
    department: "Filiale ",
    company: "Firma ",
    enter_code: "Code eingeben, der an die obige Telefonnummer gesendet wurde",
    code_placeholder: "SMS-Code",
    resend: "Erneut senden",
    verified: "Telefonnummer verifiziert",
    edited: "Telefonnummer bearbeitet",
    wrong_code: "Der eingegebene Verifizierungscode ist falsch",
    wait: "Sie müssen einen Moment warten, bevor wir den Verifizierungscode erneut senden",
    wrong_phone: "Falsche Telefonnummer",
  },
  insurences: {
    title: "Versicherungen",
    date: "Policengültigkeit",
  },
  monitaryStatuses: {
    accept: "Avisierungsbestätigung",
    finish: "Avisierung abgeschlossen",
    thanks: "Vielen Dank!",
    text1: "Avisierung ",
    text2: "wurde erfolgreich bestätigt",
    text3: "wurde erfolgreich abgeschlossen",
    list: "Avisierungsliste anzeigen",
  },
  help: {
    title: "Benötigen Sie Hilfe?",
    text: "Wenn Probleme bei der Nutzung der Anwendung aufgetreten sind oder Sie Unterstützung bei der Verwendung benötigen, kontaktieren Sie uns über die folgenden Daten:",
    phone: "Telefonnummer:",
    email: "E-Mail-Adresse:",
  },
  notifications: {
    title: "Benachrichtigungen",
    created: "erstellt",
    markAsRead: "Als gelesen markieren",
    see_all: "Alle anzeigen",
    see_all_noti: "Alle Benachrichtigungen anzeigen",
  },
  leasing: {
    title: "Leasings",
    text1: "Vereinfachtes Verfahren für Fahrzeug- und Maschinenleasing",
    text2: "Automatische Entscheidung in 15 Minuten - Fahrzeuge",
    text3:
      "Bei einer ersten Anzahlung für Fahrzeuge in Höhe von 10% - wir benötigen keine Finanzdokumente, nur das Ausfüllen des Antrags bei einer Geschäftstätigkeit über 12 Monate. Für neu gegründete Unternehmen vereinfachtes Verfahren bei einer ersten Anzahlung von 20% des Fahrzeugwerts.",
    download: "Antrag zum Ausfüllen herunterladen",
    no_applications: "Keine Anträge",
    add_application: "Neuen Antrag hinzufügen",
    your_applications: "Ihre Anträge",
    confirm: "Sind Sie sicher, dass Sie diesen Antrag löschen möchten?",
    action: "Diesen Antrag annehmen oder ablehnen",
    info: "Wir haben Ihren Leasingantrag erhalten. Wir benachrichtigen Sie, wenn er bearbeitet wurde.",
  },
  chat: {
    show_chats_for: "Chats anzeigen für:",
    no_chats: "Keine aktiven Chats",
    no_messages: "Keine Nachrichten",
    go_to_chat: "Zum Chat gehen",
    chat_with: "Chat mit:",
    chat_for: "Chat für:",
    send: "Senden",
    create_chat: "Neuen Chat erstellen",
    create_chat_with: "Ich möchte einen Chat erstellen mit:",
    no_authorized: "Keine autorisierten Filialen zum Chatten.",
    create: "Chat erstellen",
    goto: "Zum Chat gehen",
  },

  unfolded: {
    phone: "Telefon",
    created: "Erstellt",
    transaction: "Transaktion",
    from: "Von",
    to: "Nach",
    when: "Wann",
    offers: "Angebote",
    lp: "Nr.",
    id_logi: "XLplanner-ID",
    company_name: "Firmenname",
    company_address: "Firmenadresse",
    company_owner: "Firmeninhaber",
    details: "Details anzeigen",
    doc: "Dokument",
    name: "Name",
    when_added: "Wann hinzugefügt",
    action: "Aktion",
    auction: "Auktion",
    status: "Status",
    amount: "Betrag",
    no_offers: "Keine Angebote in dieser Auktion",
  },
  snackbars: {
    offer_added_success: "Auktionsangebot erfolgreich hinzugefügt",
    error_creating_chat: "Beim Erstellen des Chats ist ein Fehler aufgetreten. Überprüfen Sie, ob eine Filiale ausgewählt wurde.",
    error: "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut.",
    errorEmpty: "Das Feld darf nicht leer sein.",
    invite_success: "Firma erfolgreich zur Einladungsliste hinzugefügt",
    length_error: "Das Namensfeld ist zu lang. Maximale Länge ist 30.",
    max_length: "Maximale Länge ist",
    vin: "Die VIN muss 17 Zeichen lang sein",
    error50: "Das Feld darf maximal 50 Zeichen haben und darf nicht leer sein.",
    not_found_company: "Steuernummer in der GUS-Datenbank nicht gefunden",
    allowSms: "SMS-Benachrichtigungen erlauben",
    auto_offering: "Grenze für Auto-Überbieten wählen",
    choose_car: "Fahrzeug wählen",
    no_chats: "Keine Chats",
    no_message: "Keine Nachricht zu senden",
    nip_wrong: "Steuernummer in der GUS-Datenbank nicht gefunden",
    nip_taken: "Eine Firma mit dieser Steuernummer existiert bereits in der XLplanner-Anwendung.",
    no_group: "Keine Gruppe ausgewählt.",
    no_departments: "Keine Filialen ausgewählt.",
    no_department: "Keine Filiale ausgewählt, der die Gruppe zugeordnet werden soll.",
    pick_group: "Zielgruppe wählen",
    no_name: "Sie haben die Gruppe nicht benannt",
    chat_create: "Die ausgewählte Firma hat keine Filialen, mit denen ein Chat erstellt werden kann.",
    no_address: "Keine Adresse",
    no_companies: "Keine Firmen in den angegebenen Suchkategorien",
    company_edit_success: "Firma erfolgreich bearbeitet",
    department_edit: "Filialdaten bearbeiten",
    user_edit: "Benutzerdaten bearbeiten",
    no_results: "Keine Suchergebnisse",
    delete_package: "Sind Sie sicher, dass Sie das Paket löschen möchten?",
    edit: "Daten bearbeiten",
    no_authorizations:
      "In dieser Liste erscheinen alle Ihre Autorisierungen mit Lagern. Gehen Sie zur Lagerliste im Tab Zeitfenster, um die erste Autorisierung zu erstellen.",
    no_authorizations_warehouse:
      "In dieser Liste erscheinen alle Ihre Autorisierungen mit Spediteuren. Sie erhalten eine Benachrichtigung, wenn eine neue Anfrage von einem Spediteur gesendet wird.",
    to_add_car: "Um ein Fahrzeug hinzuzufügen, müssen Sie zuerst Filialen haben",
    no_offers_in_auction: "Keine Angebote in dieser Auktion",
    group_created: "Gruppe erfolgreich erstellt.",
    group_empty_error: "Sie müssen mindestens eine existierende Filiale zur Gruppe hinzufügen.",
    changes_saved: "Änderungen erfolgreich gespeichert.",
    chat_redirect_error: "Chat nicht gefunden",
    permission_error: "Keine Berechtigung",
    permission_detailed: "Sie können keine Konten anderer Administratoren, Ihr eigenes Konto verwalten oder wenn Sie selbst kein Administrator sind.",
  },

  raport: {
    auction_over: "Auktion beendet",
    action_type: "Aktionstyp",
    date: "Ausführungsdatum",
    creator: "Ausführender",
    creator_short: "Ausführender",
    about: "Betrifft",
    ip: "IP-Adresse und Ort",
    details: "Details",
    before: "Vor der Änderung",
    after: "Nach der Änderung",
    types: {
      department_remove_worker: "Mitarbeiter aus Filiale entfernt",
      department_add_worker: "Mitarbeiter zur Filiale hinzugefügt",
      company_remove_worker: "Mitarbeiter aus Firma entfernt",
      company_add_worker: "Mitarbeiter zur Firma hinzugefügt",
      user_data_changed: "Benutzerdaten geändert",
      user_data_changed222: "Benutzerdaten geändert",
      company_leasing_application_pending: "Leasingantrag hinzugefügt",
      company_change_status_blocked: "Firma gesperrt",
      company_change_status_activated: "Firma autorisiert",
      company_change_status: "Firmenstatus geändert",
      change_company_status: "Firmenstatus geändert",
      leasing_application: "Leasingstatus geändert",
      issue_auction: "Auktion hinzugefügt",
      user_change_status_blocked: "Mitarbeiter gesperrt",
      user_change_status_activated: "Mitarbeiter autorisiert",
      user_change_status_deleted: "Mitarbeiter gelöscht",
      admin_add_worker: "XLplanner-Mitarbeiter hinzugefügt",
      admin_edit_user_profile: "Admin bearbeitete Benutzerprofil",
      admin_add_payment_price_list_item: "Position zur Preisliste hinzugefügt",
      admin_leasing_status_rejected: "Leasingantrag abgelehnt",
      admin_leasing_status_accepted: "Leasingantrag angenommen",
      admin_edit_department_profile: "Admin bearbeitete Filiale",
      admin_edit_company_profile: "Admin bearbeitete Firma",
      admin_edit_payment_price_list_item: "Preisliste bearbeitet",
      admin_delete_payment_price_list_item: "Position aus Preisliste gelöscht",
      auction_submitting_a_bid: "Angebot zur Auktion hinzugefügt",
      company_monitory_note_purchase: "Zeitfenster gekauft",
      company_subscription_purchase: "Abonnement gekauft",
      department_send_chat_message: "Nachricht im Chat gesendet",
      company_add_department: "Firma fügte Filiale hinzu",
      company_krs_cdig_document_upload: "Firma fügte Handelsregisterdokument hinzu",
      department_send_chat_message_with_attachment: "Filiale sendete Nachricht mit Anhang",
      edit_auction: "Auktion bearbeitet",
    },
    keys: {
      companyId: "Firmen-ID",
      orderNumber: "Auftragsnummer",
      currency: "Währung",
      remarks: "Zusätzliche Infos",
      amount: "Betrag",
      status: "Status",
      country: "Land",
      auctionSubId: "Auktions-ID",
      userDepartment: "Entfernter Mitarbeiter",
      user: "Mitarbeiter",
      auctionId: "Hinzugefügte Auktion",
      originalname: "Dateiname",
      fileId: "Datei herunterladen",
      subId: "Nummer",
      email: "E-Mail",
      name: "Vorname/Name",
      message: "Nachrichteninhalt",
      surname: "Nachname",
      phone: "Telefon",
      userPhone: "Telefon",
      phoneNumberVerified: "Tel.-Nr. verifiziert",
      isAccountVerified: "Konto verifiziert",
      allowSms: "Erlaubt SMS-Kontakt",
      price: "Preis",
      amountSubscriptionDays: "Anzahl Abonnementtage",
      departmentPhone: "Filial-Telefonnummer",
      address: "Adresse",
      city: "Stadt",
      zipCode: "Postleitzahl",
      countryCode: "Ländercode",
      contractTerms: "Vertragsbedingungen",
      contacTermsHelper: "Vertragsbedingungen in PDF-Datei hinzufügen",
      shortName: "Name",
      companyAddresses: "Firmenadresse",
      companyPhone: "Firmen-Telefonnummer",
      companyNip: "Steuernummer",
      companyName: "Name",
      addedUser: "Hinzugefügter Mitarbeiter",
      isDeleted: "Ob gelöscht",
      monitoryNotesNumber: "Anzahl Zeitfenster",
    },
    statuses: {
      blocked: "Gesperrt",
      activated: "Aktiviert",
      deleted: "Gelöscht",
      pending: "Wartend",
      accepted: "Angenommen",
      rejected: "Abgelehnt",
      initialized: "Begonnen",
      waiting_for_acceptance: "Wartet",
    },
  },

  change_type_messages: {
    confirm_action: "Auswahl bestätigen",
    change_account_type: "Kontotyp ändern",
    general: "Die Kontoänderung bewirkt folgende Änderungen:",
    confirmation_text: "Sind Sie sicher, dass Sie den Kontotyp von {0} zu {1} ändern möchten?",
    driver_to_warehouse:
      "Alle Spediteursfilialen werden in Lager umgewandelt;Der Zugang zum Portemonnaie geht verloren;Alle Autorisierungen werden gelöscht;Alle gespeicherten Fahrzeuge gehen verloren;Alle eingereichten Angebote in Auktionen sowie alle zugewiesenen Aufträge und die Börse werden storniert;Firmen- und Filialdaten bleiben unverändert",
    warehouse_to_driver:
      "Alle Lager werden in Spediteursfilialen umgewandelt;Alle geplanten und wartenden Avisierungen werden storniert;Alle Autorisierungen werden gelöscht;Der Kontotyp kann nicht geändert werden, wenn in einem der Lager gerade eine Avisierung läuft;Firmen- und Filialdaten bleiben unverändert",
    driver_to_factory:
      "Alle Spediteursfilialen werden in Herstellerfilialen umgewandelt;Der Zugang zum Portemonnaie geht verloren;Alle Autorisierungen werden gelöscht;Alle gespeicherten Fahrzeuge gehen verloren;Alle eingereichten Angebote in Auktionen sowie alle zugewiesenen Aufträge und die Börse werden storniert;Firmen- und Filialdaten bleiben unverändert",
    factory_to_warehouse:
      "Alle Hersteller-Filialen und -Lager werden in Lager umgewandelt;Alle Autorisierungen werden gelöscht;Alle erstellten Börsengeschäfte sowie Aufträge, die Spediteuren zugewiesen wurden, werden storniert;Firmen- und Filialdaten bleiben unverändert",
    warehouse_to_factory:
      "Alle Lager werden in Spediteurslager umgewandelt;Alle geplanten und wartenden Avisierungen werden storniert;Alle Autorisierungen werden gelöscht;Der Kontotyp kann nicht geändert werden, wenn in einem der Lager gerade eine Avisierung läuft;Firmen- und Filialdaten bleiben unverändert",
    factory_to_driver:
      "Alle Hersteller-Filialen und -Lager werden in Spediteursfilialen umgewandelt;Alle Autorisierungen werden gelöscht;Alle erstellten Börsengeschäfte sowie Aufträge, die Spediteuren zugewiesen wurden, werden storniert;Firmen- und Filialdaten bleiben unverändert",
    errors: {
      404: "Firma nicht gefunden",
      403: "Sie können den Kontotyp nicht ändern, weil darauf laufende Avisierungen sind",
    },
  },
  blocking: {
    title: "Möchten Sie die Filiale sperren?",
    empty: "Hier werden die von Ihnen gesperrten Filialen angezeigt.",
    how: "Eine Filiale kann über den Filialdetailsbildschirm gesperrt werden, der beispielsweise über Autorisierungen erreichbar ist.",
    go_to_list: "Filialliste",
    info: "Sie können keine Avisierungen mit einer gesperrten Filiale oder einem gesperrten Lager erstellen. Sie sehen auch keine Auktionen, die von diesen erstellt wurden. Die Sperrliste kann in den Einstellungen bearbeitet werden.",
    choose_department: "Wählen Sie Ihre Filiale",
    choosing: "Wählen Sie die Filiale aus, für die Sie sperren möchten",
    choosing_unblock: "Wählen Sie die Filiale aus, für die Sie entsperren möchten",
    choosing2: "Sie können mehrere Positionen auswählen.",
    list_title: "Liste der Gesperrten",
    return: "Wiederherstellen",
    unblocked: "Filiale wurde wiederhergestellt",
    unblock_title: "Sind Sie sicher, dass Sie die Filiale wiederherstellen möchten?",
  },
  factoring: {
    do_you_want: "Möchten Sie Factoring?",
    commission: "Die Provision für Factoring beträgt ",
    list: "Factoring-Übersicht",
    search: "Suche nach Auktions-ID, Firma, Steuernummer...",
    searchLong: "Auktions-ID, Firmen-ID oder Steuernummer eingeben, um Factoring zu suchen",
  },
  groups: {
    name: "Gruppenname",
    members: "Anzahl Mitglieder",
  },
  adverts: {
    add: "Werbung hinzufügen",
    pic: "Werbebild",
    link: "Link (optional)",
    save: "Werbung speichern",
    saving: "Speichern...",
    deleting: "Sind Sie sicher, dass Sie die Werbung löschen möchten?",
    pic_error: "Sie müssen mindestens ein Bild hinzufügen",
  },
  confirmings: {
    driver_came: "Bestätigen Sie wirklich die Ankunft des Fahrers?",
    driver_absent: "Bestätigen Sie wirklich die Abwesenheit des Fahrers?",
  },
  calendar_request_modal: {
    title: "Anfrage zur Kalenderausfüllung senden",
    subtitle: "Wählen Sie die Form der Benachrichtigung",
    checkbox1: "Ich möchte eine SMS-Benachrichtigung erhalten",
    checkbox2: "Ich möchte eine E-Mail-Benachrichtigung erhalten",
    button: "Anfrage senden",
  },
  role_descriptions: {
    pilot: {
      owner:
        "Hat alle Berechtigungen (Mitarbeiter hinzufügen, Mitarbeiter bearbeiten, Fotos, Logo, Firmendokumente hinzufügen, Fahrzeuge hinzufügen, Angebote für Aufträge abgeben).",
      admin: "Kann Dokumente zur Firma hinzufügen, Mitarbeiter zur zugewiesenen Filiale hinzufügen, Fahrzeuge hinzufügen und Angebote abgeben.",
      worker: "Kann Fahrzeuge hinzufügen und Angebote für Aufträge abgeben.",
    },
    warehouse: {
      owner:
        "Hat alle Berechtigungen (Lager hinzufügen, Filialen autorisieren, Mitarbeiter hinzufügen, Mitarbeiter bearbeiten, Fotos, Logo, Firmendokumente hinzufügen, Avisierungskalender erstellen, Avisierungen durchführen, Leasinganträge stellen).",
      admin:
        "Kann Dokumente zur Firma hinzufügen, Mitarbeiter zur zugewiesenen Filiale hinzufügen, Avisierungskalender erstellen, Avisierungen durchführen.",
      worker: "Kann Avisierungskalender erstellen, Avisierungen der zugewiesenen Filiale durchführen.",
    },
    driver: {
      owner:
        "Hat alle Berechtigungen (Mitarbeiter hinzufügen, Mitarbeiter bearbeiten, Fotos, Logo, Firmendokumente hinzufügen, Auktionen hinzufügen, Gruppen erstellen)",
      admin: "Kann Dokumente zur Firma hinzufügen, Mitarbeiter hinzufügen, an der Börse teilnehmen",
      worker: "Kann Firmendaten einsehen, an der Börse teilnehmen",
    },
  },

  info_icons: infoIcons,
  transport_list: {
    list: "Transportliste",
    pick_road: "Wählen Sie einen Routenabschnitt und sehen Sie Details sowie Unterschriften",
    signatures_word: "Unterschriften",
    sign: "Unterschreiben",
    see: "Anzeigen",
    sender: "Absender",
    particles: "Teil zugeordnet zur Entladung",
    pallets: "Anz. Paletten",
    items: "Anz. Stück",
    weight: "Anz. Tonnen",
    type: "Typ",
    signatures: {
      driver: "Fahrer-Unterschrift",
      sender: "Absender-Unterschrift",
      receiver: "Empfänger-Unterschrift",
    },
  },
  roles: {
    OWNER: "Administrator",
    ADMINISTRATOR: "Leiter",
    WORKER: "Mitarbeiter",
  },
  routes: routes,
  files: {
    errors: {
      size: "Dateigröße darf 10MB nicht überschreiten",
    },
  },
  reporting: {
    terms: {
      sendSuccess: "Meldung gesendet",
      sendError: "Problem beim Senden der Meldung aufgetreten",
      send: "Problem mit Vertragsbedingungen melden",
      enterMessage: "Nachricht eingeben, um Problem mit Vertragsbedingungen zu melden:",
      sendShort: "Meldung senden",
    },
  },

  "missing-department-modal": {
    "title-warehouse": "Lager erstellen",
    "title-department": "Filiale erstellen",
    "warehouse-description":
      "Lager sind das Grundelement von XLplanner. Alle wichtigen Tätigkeiten in der Anwendung führen Sie aus, indem Sie ein Lager zuweisen, auf das sich die geplante Aktion beziehen soll. Fügen Sie das erste Lager hinzu, um die Anwendung vollständig nutzen zu können.",
    "department-description":
      "Filialen sind das Grundelement von XLplanner. Alle wichtigen Tätigkeiten in der Anwendung führen Sie aus, indem Sie eine Filiale zuweisen, auf die sich die geplante Aktion beziehen soll. Fügen Sie die erste Filiale hinzu, um die Anwendung vollständig nutzen zu können.",
  },
  mobile: {
    exchange_orders: "Auftragsbörse",
    exchange_pilots: "Pilotenbörse",
  },
};
